export const bn_language_data = {
  Loading: "লোড হচ্ছে",
  Login: "প্রবেশ করুন",
  LoginWithUsernameandPassword:
    "আপনার ব্যবহারকারী নাম এবং পাসওয়ার্ড দিয়ে লগ ইন করুন",
  UserID: "ব্যবহারকারী আইডি",
  Password: "পাসওয়ার্ড",
  EnterUserName: "ব্যবহারকারীর নাম লিখুন",
  EnterPassword: "পাসওয়ার্ড লিখুন",
  EnterPasswordValid: "পাসওয়ার্ড 8 থেকে 16 অক্ষরের মধ্যে হতে হবে।",
  EnterPasswordPolicy:
    "পাসওয়ার্ড অবশ্যই ৮-১৬ টি অক্ষরের হতে হবে, একটি বড় হাতের অক্ষর, একটি ছোট হাতের অক্ষর, একটি সংখ্যা এবং একটি বিশেষ অক্ষর অবশ্যই থাকতে হবে, কোনও স্থানে স্পেস অনুমোদিত নয়।",
  ForgotPassword: "পাসওয়ার্ড ভুলে গেছেন",
  UsernameisRequired: "ব্যবহারকারীর নাম একটি আবশ্যক",
  PasswordisRequired: "পাসওয়ার্ড একটি আবশ্যক",
  MobileNoisRequired: "মোবাইল নম্বর প্রয়োজন।",
  MobileNoisValid: "বৈধ মোবাইল নম্বর লিখুন.",
  UserNm: "ব্যবহারকারীর নাম",
  UsernamenandPasswordisRequired: "ব্যবহারকারীর নাম এবং পাসওয়ার্ড একটি আবশ্যক",
  ThisFieldisrequired: "ঘরটি অবশ্যই পূরণ করতে হবে",
  Next: "পরবর্তী",
  backtologin: "প্রবেশ করতে পেছান",
  Save: "সংরক্ষণ",

  Yes: "হ্যাঁ",
  No: "না",
  Nodatafound: "কোন তথ্য পাওয়া যায়নি..!",
  Confirmation: "নিশ্চিতকরণ",
  Filter: "ছাঁকনি",
  Apply: "আবেদন করুন",
  Clear: "পরিষ্কার",
  FailedToAddFollowingFilesForUpload:
    "আপলোড করার জন্য নিম্নলিখিত ফাইল যোগ করতে ব্যর্থ",
  FileUpload: "ফাইল আপলোড",
  FileViewer: "ফাইল ভিউয়ার",
  File: "ফাইল",
  Type: "টাইপ",
  Size: "আকার",
  DoyouwanttosavethisRequest: "আপনি এই অনুরোধ সংরক্ষণ করতে চান?",
  DoyouwanttosavethisRecord: "আপনি কি এই রেকর্ড সংরক্ষণ করতে চান??",
  DoyouwanttoacceptthisRequest: "আপনি কি এই অনুরোধ গ্রহণ করতে চান?",
  DoYouwanttorejectthisRequest: "আপনি কি এই অনুরোধ প্রত্যাখ্যান করতে চান?",
  Doyouwanttorevertthisrequest: "আপনি কি এই অনুরোধটি ফিরিয়ে দিতে চান?",
  Youcannotacceptyourownentry: "আপনি আপনার নিজের এন্ট্রি গ্রহণ করতে পারবেন না.",
  Youcannotrejectyourownentry:
    "আপনি আপনার নিজের এন্ট্রি প্রত্যাখ্যান করতে পারবেন না.",
  Youcannotconfirmyourownentry:
    "আপনি আপনার নিজের এন্ট্রি নিশ্চিত করতে পারবেন না.",
  RecordUpdatedsuccessfully: "রেকর্ড সফলভাবে আপডেট করা হয়েছে৷",
  ImageUpdatedsuccessfully: "ছবি সফলভাবে আপডেট করা হয়েছে।",
  Somethingwenttowrong: "কিছু ভুল হয়েছে..",
  Recordssuccessfullydeleted: "রেকর্ড সফলভাবে মুছে ফেলা হয়েছে",
  Requesthasbeenalreadyaccepted: "অনুরোধ ইতিমধ্যে গৃহীত হয়েছে.",
  Requesthasbeenalreadyrejected: "অনুরোধ ইতিমধ্যে প্রত্যাখ্যান করা হয়েছে.",
  Areyousuretoupdateservices: "আপনি পরিষেবা আপডেট করতে নিশ্চিত?",
  Passwordsuccessfullyreset: "পাসওয়ার্ড সফলভাবে রিসেট করা হয়েছে",
  success: "সাফল্য",
  Deleting: "মুছে ফেলা হচ্ছে...",
  profile: {
    UserProfile: "সেভ ইউজার প্রোফাইল",
    EnableTOTPAuth: "T-OTP প্রমাণ সক্ষম করুন",
    DisableTOTPAuth: "অক্ষম T-OTP প্রমাণীকরণ",
    ChangePassword: "পাসওয়ার্ড পরিবর্তন করুন",
    LoginDate: "লগইন তারিখ",
    UserID: "ব্যবহারকারী আইডি",
    Name: "নাম",
    LoginID: "লগইন আইডি",
    LoginFlag: "লগইন পতাকা",
    LogoutDate: "লগআউট তারিখ",
    ActivityRemarks: "কার্যকলাপ মন্তব্য",
    IPAddress: "আইপি ঠিকানা",
    ReleasedUser: "রিলিজড ইউজার",
    ReleasedDate: "মুক্তির তারিখ",
    SrNo: "ক্রম নং",
    UserLevel: "ব্যবহারকারীর স্তর",
    MobileNumber: "মোবাইল নম্বর",
    EnterMobileNumber: "মোবাইল নম্বর লিখুন",
    EmailID: "ইমেইল আইডি",
    UserGroup: "ব্যবহারকারী দল",
    UserSubType: "ইউজার সাব টাইপ",
    BranchName: "শাখার নাম",
    AllowedRelease: "অনুমোদিত রিলিজ",
    required: "এই ক্ষেত্র প্রয়োজনীয়",
    // Searchin: "{0} টি রেকর্ডে অনুসন্ধান করুন",
    Searchin: "অনুসন্ধান করুন",
    SearchinScreens: "{0} স্ক্রীনে অনুসন্ধান করুন",
    screens: "পর্দা",
    records: "রেকর্ড",
    // For Change Password in Profile
    CurrentPassword: "বর্তমান পাসওয়ার্ড",
    NewPassword: "নতুন পাসওয়ার্ড",
    ConfirmPassword: "পাসওয়ার্ড নিশ্চিত করুন",
    Close: "বন্ধ",
    PasswordValidation: "নতুন পাসওয়ার্ড পুরানো পাসওয়ার্ডের মতো হতে পারে না",
    ChangePasswordValidation:
      "পাসওয়ার্ড আলফানিউমেরিক হতে হবে এবং এর মধ্যে অন্তত একটি বিশেষ অক্ষর, একটি ছোট হাতের অক্ষর, একটি বড় হাতের অক্ষর থাকতে হবে যার মধ্যে কোনো স্থান নেই।",
    ConfirmPasswordValidation: "নতুন পাসওয়ার্ড এবং কনফার্ম পাসওয়ার্ড মেলেনি",
    SetNewPassword: "নতুন পাসওয়ার্ড সেট করুন",
    EnterConfirmPassword: "কনফার্ম পাসওয়ার্ড দিন",
    // For Password in Verify
    PasswordVerify: "পাসওয়ার্ড যাচাই করুন",
    Verify: "যাচাই করুন",
    ConfirmPasswordRequired: "পাসওয়ার্ড নিশ্চিত করুন প্রয়োজন বোধ করা হয়.",

    // For T-OTP in Profile
    EnabledAuth: "সক্ষম প্রমাণীকরণকারী৷",
    TOTP_Note: "দ্রষ্টব্য: সক্ষম প্রমাণীকরণকারী",
    TOTP_Note1:
      "QR কোড স্ক্যান করুন: প্রদত্ত QR কোড স্ক্যান করতে যেকোনো প্রমাণীকরণকারী অ্যাপ ব্যবহার করুন।",
    TOTP_Note2:
      "দ্বি-ফ্যাক্টর প্রমাণীকরণ সক্ষম করুন: উন্নত নিরাপত্তার জন্য সময়-ভিত্তিক ওয়ান-টাইম পাসওয়ার্ড (TOTP) পদ্ধতি ব্যবহার করুন।",
    TOTP_Note3:
      "প্রমাণীকরণকারী অ্যাপের বিকল্প: আপনি যেকোনো প্রমাণীকরণকারী অ্যাপ বেছে নিতে পারেন, তবে Google প্রমাণীকরণের সুপারিশ করা হয়।",
    TOTP_Note4:
      "QR কোড স্ক্যান করার নির্দেশ: ব্যবহারকারীকে তাদের নির্বাচিত প্রমাণীকরণকারী অ্যাপে QR কোড স্ক্যান করতে নির্দেশ দিন।",
    TOTP_Note5:
      "OTP যাচাই করুন: স্ক্যান করার পরে, ব্যবহারকারীকে অ্যাপ দ্বারা তৈরি ওয়ান-টাইম পাসওয়ার্ড (OTP) যাচাই করতে হবে।",
    EnterOTP: "অনুগ্রহ করে ওটিপি লিখুন",
    VerifyOTP: "OTP যাচাই করুন",

    // For OTP Verify
  },
  otp: {
    OTPAuthentication: "ওটিপি প্রমাণীকরণ",
    PleaseEnterOTP: "অনুগ্রহ করে ওটিপি লিখুন",
    Back: "পেছনে",
    Verify: "যাচাই করুন",
    ResendOTP: "OTP আবার পাঠান",
    EnterOTPDigit: "অনুগ্রহ করে একটি 6 সংখ্যার OTP নম্বর লিখুন৷",
    ResendOTPIn: "OTP আবার পাঠান",
    Scecond: "সেকেন্ড",
  },
  appBar: {
    Branch: "শাখা",
    LastLogin: "শেষ লগইন",
    UserID: "ব্যবহারকারী আইডি",
    Role: "ভূমিকা",
    Profile: "প্রোফাইল",
    Logout: "প্রস্থান",
  },

  dashBoard: {
    LatestTransactions: "সর্বশেষ লেনদেন",
    TrafficByDevice: "ডিভাইস দ্বারা ট্রাফিক",
    Success: "সফলতা",
    Fail: "ব্যর্থ",
    Today: "আজ",
    LastWeek: "গত সপ্তাহে",
    LastMonth: "গত মাসে",
  },
  Web: "ওয়েব",
  IOS: "আইওএস",
  Android: "অ্যান্ড্রয়েড",
  Huawei: "হুয়াওয়ে",

  // All Screen
  Custom: "কাস্টম",
  AllScreens: "সব স্ক্রিন",
  ScreenName: "স্ক্রিন নাম",
  UserCode: "ব্যবহারকারী কোড",
  SystemCode: "সিস্টেম কোড",
  Release: "রিলিজ",
  ServiceActiveDeactiveConfiguration: "সেবা সক্রিয় / নিষ্ক্রিয় কনফিগারেশন",
  SrNo: "শ্রেণীবিন্যাস নং",
  ServiceName: "সেবার নাম",
  Status: "অবস্থা",
  AccessChannel: "অ্যাক্সেস চ্যানেল",
  CardUser: "কার্ড ব্যবহারকারী",
  NonCardUser: "গৈর-কার্ড ব্যবহারকারী",
  ServiceStopAlertMessage: "সেবা বন্ধ সতর্কতা বার্তা",
  EnterServiceStopAlertMessage: "সেবা বন্ধ সতর্কতা বার্তা লিখুন",
  TotalNoofRecords: "মোট সংখ্যা",
  MessageEnglish: "বার্তা (ইংরেজি)",
  EnterMessageEnglish: "বার্তা (ইংরেজি) লিখুন",
  MessageLocal: "বার্তা (স্থানীয়)",
  EnterMessageLocal: "বার্তা (স্থানীয়) লিখুন",
  ServiceDeactivationConfigurationDetails: "সেবা অক্ষমকরণ কনফিগারেশনের বিবরণ",
  FromDate: "তারিখ থেকে*",
  ToDate: "তারিখ পর্যন্ত*",
  Active: "সক্রিয়",
  Action: "অ্যাকশন",
  FromDateToDate: "তারিখ হতে কম হওয়া উচিত তারিখে।",
  ToDateFromDate: "তারিখ থেকে বেশি হতে উচিত তারিখে।",
  FromDateToDatePrevious: "পূর্ববর্তী তারিখ হওয়া উচিত তারিখ থেকে।",
  Cancel: "বাতিল",
  Edit: "সম্পাদনা করুন",
  New: "নতুন",
  confirm: "নিশ্চিত করুন",
  Close: "বন্ধ করুন",
  // Closes: "বন্ধ করুন",
  Add: "যোগ করুন",
  AddRow: "সারি যোগ করুন",
  EditDetail: "বিস্তারিত সম্পাদনা করুন",
  ViewDetails: "বিস্তারিত দেখুন",
  view: "দেখুন",
  Delete: "মুছে ফেলুন",
  Update: "আপডেট করুন",
  ViewFile: "ফাইল দেখুন",
  ClearAll: "সব পরিষ্কার করুন",
  Ok: "ঠিক আছে",
  PopulateBusinessDay: "ব্যবসায়িক দিন প্রসারণ করুন",
  DateWiseServiceDisable: "তারিখ অনুযায়ী সেবা অক্ষম",
  Messages: "বার্তা",
  Selected: "নির্বাচিত",
  // Rowsperpage: "পৃষ্ঠা প্রতি সারি:",

  //Marquee Text Configuration
  MarqueeTextConfiguration: "মার্কী টেক্সট কনফিগারেশন",
  Channel: "চ্যানেল",
  MarqueeTextEnglish: "মার্কী টেক্সট (ইংরেজি)",
  MarqueeTextLocal: "মার্কী টেক্সট (স্থানীয়)",
  EffectiveFrom: "কার্যকর হতে শুরু",
  EffectiveTo: "কার্যকর হতে",
  EnterEffectiveFrom: "কার্যকর হতে শুরু লিখুন",
  EnterMarqueeTextEnglish: "মার্কী টেক্সট (ইংরেজি) লিখুন",
  EnterMarqueeTextLocal: "মার্কী টেক্সট (স্থানীয়) লিখুন",
  Mustbeavaliddate: "বৈধ একটি তারিখ হতে হবে",
  EffectiveToshouldbegreaterthanorequaltoEffectiveFrom:
    "কার্যকর থেকে বেশি অথবা সমান করা উচিত কার্যকর হতে।",
  Wouldyouliketodeletetheselectedrecord:
    "আপনি কি নির্বাচিত রেকর্ডটি মুছতে চান?",
  CommonMessageTemplete: "কমন মেসেজ টেমপ্লেট",
  SelectCommonMessageTemplete: "কমন মেসেজ টেমপ্লেট সিলেক্ট করুন",

  //Email Account Setup

  EmailAccountSetup: "ই-মেইল SMTP সার্ভার কনফিগারেশন",
  SentByName: "নামে প্রেরিত",
  SMTPServerIP: "SMTP সার্ভার আইপি",
  Port: "পোর্ট",
  SSLEnabled: "SSL সক্রিয়",
  SecurePasswordAuthentication: "নিরাপদ পাসওয়ার্ড প্রমাণীকরণ",
  SecurePasswordAuthenticationEnabled: "নিরাপদ পাসওয়ার্ড প্রমাণীকরণ সক্রিয়",
  PassAuth: "পাসওয়ার্ড প্রমাণীকরণ",
  UserName: "ব্যবহারকারীর নাম",
  SMTPServer: "SMTP সার্ভার",
  PortNo: "পোর্ট নম্বর",
  NoteEMailSMTP:
    "নোট: - দয়া করে নিশ্চিত করুন যে আপনার ই-মেইল অ্যাকাউন্টটি SMTP এনেবল করা হয়েছে।",
  EnterSentByName: "নামে প্রেরিত লিখুন",
  EnterSMTPServer: "SMTP সার্ভার লিখুন",
  EnterPortNo: "পোর্ট নম্বর লিখুন",
  // EnterUserName: "ব্যবহারকারীর নাম লিখুন",

  // District Master
  DistrictMaster: "জেলা মাস্টার",
  DistrictCode: "জেলা কোড",
  DistrictName: "জেলা নাম",
  DivisionCode: "বিভাগ কোড",
  DivisionName: "বিভাগ নাম",
  GeoCode: "ভূ-কোড",
  DistCD: "জেলা সি.ডি.",
  EnterDistrictCode: "জেলা কোড লিখুন",
  EnterDistrictName: "জেলা নাম লিখুন",
  EnterDivisionCode: "বিভাগ কোড লিখুন",
  EnterDivisionName: "বিভাগ নাম লিখুন",
  EnterGeoCode: "ভূ-কোড লিখুন",
  EnterDistCD: "জেলা সি.ডি. লিখুন",

  // Service Wise Configuration

  ServiceWiseConfiguration: "সেবা অনুযায়ী কনফিগারেশন",
  Description: "বিবরণ",
  EnterDescription: "বিবরণ লিখুন",
  DailyLimit: "দৈনিক সীমা",
  MinimumAmount: "ন্যূনতম পরিমাণ",
  MaximumAmount: "সর্বাধিক পরিমাণ",
  TransactionType: "লেনদেনের প্রকার",
  ConfirmStatus: "অনুমোদনের অবস্থা",
  ModifiedBy: "পরিবর্তনকারী",
  ModifiedDate: "পরিবর্তনের তারিখ",
  EnterDailyLimit: "দৈনিক সীমা লিখুন",
  WeeklyLimit: "সাপ্তাহিক সীমা",
  EnterWeeklyLimit: "সাপ্তাহিক সীমা লিখুন",
  MonthlyLimit: "মাসিক সীমা",
  EnterMonthlyLimit: "মাসিক সীমা লিখুন",
  EnterMinimumAmount: "ন্যূনতম পরিমাণ লিখুন",
  EnterMaximumAmount: "সর্বাধিক পরিমাণ লিখুন",
  CardMinimumAmount: "কার্ডের ন্যূনতম পরিমাণ",
  EnterCardMinimumAmount: "কার্ডের ন্যূনতম পরিমাণ লিখুন",
  Execution: "কার্যকরণ",
  StartTime: "শুরুর সময়",
  EnterStartTime: "শুরুর সময় লিখুন",
  EndTime: "শেষ সময়",
  EnterEndTime: "শেষ সময় লিখুন",
  VATPercentage: "ভ্যাট শতাংশ",
  EnterVATPercentage: "ভ্যাট শতাংশ লিখুন",
  MerchantID: "মার্চেন্ট আইডি",
  EnterMerchantID: "মার্চেন্ট আইডি লিখুন",
  TerminalID: "টার্মিনাল আইডি",
  EnterTerminalID: "টার্মিনাল আইডি লিখুন",
  WorkingDayStartFrom: "কার্যকারিতা দিন হতে শুরু",
  CoolDownPeriodInMinute: "শীতলকার সময় (মিনিটে)",
  EnterCoolDownPeriodInMinute: "শীতলকার সময় লিখুন (মিনিটে)",
  MaxDailyCount: "সর্বোচ্চ দৈনিক গণনা",
  EnterMaxDailyCount: "সর্বোচ্চ দৈনিক গণনা লিখুন",
  MaxMonthlyCount: "সর্বাধিক মাসিক গণনা",
  EnterMaxMonthlyCount: "সর্বাধিক মাসিক গণনা লিখুন",
  AmountLabel: "পরিমাণ লেবেল",
  Accept: "গ্রহণ করুন",
  Revert: "প্রত্যাবর্তন",
  Reject: "প্রত্যাখ্যান",

  Charge: "চার্জ",
  ServiceChargeTemplate: "সেবা চার্জ টেম্পলেট",
  SelectServiceChargeTemplate: "সেবা চার্জ টেম্পলেট নির্বাচন করুন",
  ServiceChargeAccount: "সেবা চার্জ অ্যাকাউন্ট",
  EnterServiceChargeAccount: "সেবা চার্জ অ্যাকাউন্ট লিখুন",
  VATAccount: "ভ্যাট অ্যাকাউন্ট",
  EnterVATAccount: "ভ্যাট অ্যাকাউন্ট লিখুন",
  TransactionParticulars: "লেনদেনের বিশদ",
  FinacleSuspenseCreditAccount: "ফিনাকেল সাসপেন্স ক্রেডিট অ্যাকাউন্ট",
  EnterFinacleSuspenseCreditAccount:
    "ফিনাকেল সাসপেন্স ক্রেডিট অ্যাকাউন্ট লিখুন",
  FinacleSuspenseDebitAccount: "ফিনাকেল সাসপেন্স ডেবিট অ্যাকাউন্ট",
  EnterFinacleSuspenseDebitAccount: "ফিনাকেল সাসপেন্স ডেবিট অ্যাকাউন্ট লিখুন",
  AbabilSuspenseCreditAccount: "আবাবিল সাসপেন্স ক্রেডিট অ্যাকাউন্ট",
  EnterAbabilSuspenseCreditAccount: "আবাবিল সাসপেন্স ক্রেডিট অ্যাকাউন্ট লিখুন",
  AbabilSuspenseDebitAccount: "আবাবিল সাসপেন্স ডেবিট অ্যাকাউন্ট",
  EnterAbabilSuspenseDebitAccount: "আবাবিল সাসপেন্স ডেবিট অ্যাকাউন্ট লিখুন",
  CardSuspenseCreditAccount: "কার্ড সাসপেন্স ক্রেডিট অ্যাকাউন্ট",
  EnterCardSuspenseCreditAccount: "কার্ড সাসপেন্স ক্রেডিট অ্যাকাউন্ট লিখুন",
  CardSuspenseDebitAccount: "কার্ড সাসপেন্স ডেবিট অ্যাকাউন্ট",
  EnterCardSuspenseDebitAccount: "কার্ড সাসপেন্স ডেবিট অ্যাকাউন্ট লিখুন",

  FinacleTransactionParticulars: "ফিনাকেল লেনদেনের বিশদ",
  FinacleTransactionParticulars2: "ফিনাকেল লেনদেনের বিশদ 2",
  AbabilTransactionParticulars: "আবাবিল লেনদেনের বিশদ",
  AbabilTransactionParticulars2: "আবাবিল লেনদেনের বিশদ 2",
  TranzwareTransactionParticulars: "ট্রানজওয়ার লেনদেনের বিশদ",
  TranzwareTransactionParticulars2: "ট্রানজওয়ার লেনদেনের বিশদ 2",
  DynamicKeyword: "ডায়নামিক কীওয়ার্ড",
  TransactionParticularsfor: "লেনদেনের বিশদের জন্য",
  Finacle: "ফিনাকেল",
  Ababil: "আবাবিল",
  Tranzware: "ট্রানজওয়ার",
  AmountLabelMapping: "পরিমাণ লেবেল ম্যাপিং",
  AmountLabelReq: "পরিমাণ লেবেল*",
  AmountLabelisAlreadyenteredatLine: "পরিমাণ লেবেল ইতিমধ্যে লাইনে লিখা হয়েছে",
  Line: "লাইন",
  ServiceWiseConfigurationConfirmation: "সেবা ভিত্তিক কনফিগারেশন নিশ্চিতকরণ",
  ServiceWiseConfirmation: "সেবা ভিত্তিক নিশ্চিতকরণ",
  FinacleAsFromSource: "ফিনাকেল হিসাব থেকে উৎস",
  AbabilAsFromSource: "আবাবিল হিসাব থেকে উৎস",
  TranzwareAsFromSource: "ট্রানজওয়ার হিসাব থেকে উৎস",

  //  Leaves Master

  LeavesMaster: "পাতা মাস্টার",
  Template: "টেমপ্লেট",
  DeactiveDate: "নিষ্ক্রিয় তারিখ",
  EnteredBy: "প্রবেশ করেছেন",
  EnteredDate: "প্রবেশের তারিখ",
  MachineName: "যন্ত্রের নাম",
  LastModifiedBy: "সর্বশেষ সম্পাদনা করেছেন",
  LastMachineName: "সর্বশেষ যন্ত্রের নাম",
  EnteraTemplate: "একটি টেমপ্লেট লিখুন",
  NumberofLeaves: "পাতা সংখ্যা*",
  EnterNumberofLeaves: "পাতা সংখ্যা লিখুন",
  NumberofLeavesisAlreadyenteredatLine:
    "পাতার সংখ্যা ইতিমধ্যেই লাইন {0} এ প্রবেশ করানো হয়েছে",

  //Service Charge Template

  EffectiveDate: "কার্যকর তারিখ",
  LastEnteredBy: "সর্বশেষ প্রবেশকারী",
  LastEnteredDate: "সর্বশেষ প্রবেশের তারিখ",
  LastModifiedDate: "সর্বশেষ সম্পাদনার তারিখ",
  ServiceChargeTemplateConfirmation: "সেবা চার্জ টেমপ্লেট নিশ্চিতকরণ",
  ServiceChargeTemplateConfiguration: "সেবা চার্জ টেমপ্লেট কনফিগারেশন",
  FromAmount: "থেকে পরিমাণ*",
  ToAmount: "পর্যন্ত পরিমাণ*",
  ChargeAmountReq: "চার্জ পরিমাণ*",
  ChargePercent: "চার্জ শতাংশ",
  Compute: "গণনা*",
  Computes: "গণনা",
  FromAmountshouldbelessthenToAmount: "থেকে পরিমাণ থেকে কম হওয়া উচিত",
  FromAmountShouldBeGreaterThanPreviousToAmountOnSameDate:
    "থেকে পরিমাণ আগের পরিমাণের চেয়ে বড় হওয়া উচিত",
  ToAmountshouldbegreaterthanFromAmount: "পর্যন্ত পরিমাণ থেকে বড় হওয়া উচিত",

  //Holiday/Business Day Configuration
  HolidayBusinessDayConfiguration: "ছুটি / ব্যবসা দিন কনফিগারেশন",
  StartDate: "শুরুর তারিখ",
  EndDate: "শেষ তারিখ",
  HolidayConfiguration: "ছুটির কনফিগারেশন",
  InvaliddaterangeEndDateshouldbegreaterthanStartDate:
    "অবৈধ তারিখ প্রস্তুতি। 'শেষ তারিখ' অবশ্যই 'শুরুর তারিখ' থেকে বড় হতে হবে।",
  Holidays: "ছুটিদিনসমূহ",
  BusinessDayConfig: "ব্যবসা দিন কনফিগারেশন",
  Note: "নোট:",
  Note1:
    "ব্যবসা দিন ইতিমধ্যে তৈরি করা হয়েছে। আপনি ব্যবসা দিন কনফিগারেশন স্ক্রিনে চেক করতে পারেন।",
  Note2:
    "'ব্যবসা দিন তৈরি করুন' বাটনে ক্লিক করুন যেন ব্যবসা দিন তৈরি করা যায়।",
  BranchNameReq: "শাখার নাম*",
  HolidayConfig: "ছুটির কনফিগারেশন",
  BusinessDayConfiguration: "ব্যবসা দিনের কনফিগারেশন",
  Date: "তারিখ",
  DayName: "দিনের নাম",
  BusinessDayHoliday: "ব্যবসা দিন / ছুটিদিন",
  ThisValuealreadyexists: "এই মান ইতিমধ্যে বিদ্যমান।",
  Entervaliddate: "বৈধ তারিখ লিখুন",
  Dateshould: "",
  Dateshouldbebetween: "তারিখ {0} এর মধ্যে হওয়া উচিত",
  HolidayDate: "ছুটির তারিখ*",
  HolidayDescription: "ছুটির বর্ণনা*",
  HolidayType: "ছুটির ধরণ*",
  BranchNameisAlreadyenteredatLine:
    "শাখার নাম ইতিমধ্যে লাইন {0} এ প্রবেশ করানো হয়েছে",

  //Scheme Master
  SchemeMaster: "স্কীম মাস্টার",
  SchemeCode: "স্কীম কোড",
  ParentType: "প্যারেন্ট প্রকার",
  EnterParentType: "প্যারেন্ট প্রকার লিখুন",
  SchemeMasterConfirmation: "স্কীম মাস্টার নিশ্চিতকরণ",
  LeavesTemplate: "ছুটির টেমপ্লেট",
  Charges: "চার্জ",
  Service: "সেবা*",
  EnterSchemeCode: "স্কীম কোড লিখুন",
  Populate: "পূর্ণগুলি দিন",

  //Operator Master

  OperatorMasterconfirmation: "অপারেটর মাস্টার নিশ্চিতকরণ",
  OperatorMaster: "অপারেটর মাস্টার",
  OperatorType: "অপারেটর প্রকার",
  OperatorID: "অপারেটর আইডি",
  EnterOperatorID: "অপারেটর আইডি লিখুন",
  OperatorName: "অপারেটরের নাম",
  EnterOperatorName: "অপারেটরের নাম লিখুন",
  UPLOADVIEWImage: "চিত্র আপলোড / দেখুন",

  TrnParticulars: "টি.আর.এন. বিবরণ",
  EnterTrnParticulars: "টি.আর.এন. বিবরণ লিখুন",
  TrnParticulars2: "টি.আর.এন. বিবরণ 2",
  EnterTrnParticulars2: "টি.আর.এন. বিবরণ 2 লিখুন",
  ChargeTemplate: "চার্জ টেমপ্লেট",
  SpecialAmount: "বিশেষ পরিমাণ",
  AmountLabelAlreadyenteredatLine:
    "পরিমাণ লেবেল ইতিমধ্যে লাইন {0} এ প্রবেশ করানো হয়েছে",
  AccountNumber: "অ্যাকাউন্ট নাম্বার",
  EnterAccountNumber: "অ্যাকাউন্ট নাম্বার লিখুন",
  MaximumAmountshouldbeGreaterthanorequaltoMinimumAmount:
    "সর্বোচ্চ পরিমাণ সর্বনিম্ন পরিমাণের সমান অথবা বেশি হওয়া উচিত।",
  MinimumAmountshouldbeLessthanorequalToMaximumAmount:
    "সর্বনিম্ন পরিমাণ সর্বোচ্চ পরিমাণের সমান অথবা কম হওয়া উচিত।",
  Doubleclicktochangetheimage: "ইমেজ পরিবর্তন করতে ডাবল ক্লিক করুন",
  OptionisAlreadyenteredatLine:
    "বিকল্পটি ইতিমধ্যে লাইন {0} এ প্রবেশ করানো হয়েছে",
  OptionType: "অপশন প্রকার*",
  OperatorIcon: "অপারেটর আইকন",
  Uptosixrowsareallowedtobeadded: "অত্যাধিক ছয় সারি যোগ করা অনুমোদিত।",
  VIEWImage: "চিত্র দেখুন",

  // Source Parent Type Master

  SourceParentTypeMaster: "উৎস প্যারেন্ট প্রকার মাস্টার",
  SourceName: "উৎসের নাম",
  SourceType: "উৎসের প্রকার",
  EnterSourceType: "উৎসের প্রকার লিখুন",
  DisplayOrder: "ডিসপ্লে আদেশ",
  EnterDisplayOrder: "ডিসপ্লে আদেশ লিখুন",
  SignUpAllow: "নিবন্ধন অনুমোদন",
  BeneficiaryAllow: "প্রায়োজক অনুমোদন",

  //Insurance Master
  InsuranceMaster: "ইন্শুরেন্স মাস্টার",
  Code: "কোড",
  EnterCode: "কোড লিখুন",
  AccountSource: "অ্যাকাউন্ট উৎস",
  EnterTransactionParticulars: "লেনদেনের বিশদ লিখুন",
  TransactionParticulars2: "লেনদেনের বিশদ 2",
  EnterTransactionParticulars2: "লেনদেনের বিশদ 2 লিখুন",
  Remark: "মন্তব্য",
  EnterRemark: "মন্তব্য লিখুন",
  PolicyLabelEnglish: "পলিসি লেবেল (ইংরেজি)",
  EnterPolicyLabelEnglish: "পলিসি লেবেল (ইংরেজি) লিখুন",
  PolicyLabelLocal: "পলিসি লেবেল (স্থানীয়)",
  EnterPolicyLabelLocal: "পলিসি লেবেল (স্থানীয়) লিখুন",

  // University Master
  UniversityMaster: "বিশ্ববিদ্যালয় মাস্টার",
  PaymentID: "পেমেন্ট আইডি*",
  EnterPaymentID: "পেমেন্ট আইডি লিখুন",
  PaymentHeader: "পেমেন্ট হেডার*",
  EnterPaymentHeader: "পেমেন্ট হেডার লিখুন",

  // Utility Master
  UtilityMaster: "ইউটিলিটি মাস্টার",

  // Club Master
  ClubMaster: "ক্লাব মাস্টার",
  MemberDetails: "সদস্য বিবরণ",
  DownloadSample: "নমুনা ডাউনলোড করুন",
  Upload: "আপলোড",
  UploadFile: "ফাইল আপলোড করুন",
  ClubMemberDetail: "ক্লাব সদস্য বিবরণ",
  ClubMemberDetails: "ক্লাব সদস্য বিবরণ",
  MemberID: "সদস্য আইডি",
  EnterMemberID: "সদস্য আইডি লিখুন",
  MemberName: "সদস্যের নাম",
  EnterMemberName: "সদস্যের নাম লিখুন",
  MemberType: "সদস্যের প্রকার",
  EnterMemberType: "সদস্যের প্রকার লিখুন",
  MemberSince: "সদস্য হতে",
  MemberStatus: "সদস্যের অবস্থা",
  EnterMemberStatus: "সদস্যের অবস্থা লিখুন",
  EntryDate: "প্রবেশের তারিখ",
  ClubMember: "ক্লাব সদস্য",
  Futuredatesarenotallowed: "ভবিষ্যতের তারিখ অনুমোদিত নয়।",

  InvalidDateareNotAllowedinMemberSinceColumn:
    "সদস্য হওয়ার তারিখে অবৈধ তারিখ অনুমোদিত নয়",
  FutureDateareNotAllowedinMemberSinceColumn:
    "সদস্য হওয়ার তারিখে ভবিষ্যতের তারিখ অনুমোদিত নয়",
  Requiredfieldscannotbenull: "প্রয়োজনীয় ক্ষেত্র ফাঁকা রাখা যাবে না",
  DoyouwanttoUpdateClubMemberData: "আপনি কি ক্লাব সদস্যের তথ্য আপডেট করতে চান?",
  Whichformatdoyouwanttodownload: "আপনি কোন ফরম্যাটে ডাউনলোড করতে চান?",
  Excel: "এক্সেল",
  CSV: "সিএসভি",

  //Branch Master

  BranchMaster: "শাখা মাস্টার",
  BranchCode: "শাখা কোড",
  Address: "ঠিকানা",
  ContactNumber: "যোগাযোগ নম্বর",
  EmailID: "ইমেল আইডি",
  EnterEmailID: "ইমেল আইডি লিখুন",
  FileDownload: "ফাইল ডাউনলোড",

  ContactPerson: "যোগাযোগ ব্যক্তি",
  EnterContactPerson: "যোগাযোগ ব্যক্তি লিখুন",
  ContactPersonBranchManagerDetails: "যোগাযোগ ব্যক্তি / শাখা ম্যানেজারের বিবরণ",
  PayOrderAllow: "পে অর্ডার অনুমোদন",
  ChequeBookAllow: "চেকবুক অনুমোদন",
  DPSAllow: "ডিপিএস অনুমোদন",
  FDAllow: "এফডি অনুমোদন",
  District: "জেলা",
  EnterAddress: "ঠিকানা লিখুন",
  Longitude: "দ্রাঘিমা",
  EnterLongitude: "দ্রাঘিমা লিখুন",
  Latitude: "অক্ষাংশ",
  EnterLatitude: "অক্ষাংশ লিখুন",
  Phone1: "ফোন(1)",
  EnterPhone1: "ফোন(1) লিখুন",
  Phone2: "ফোন(2)",
  EnterPhone2: "ফোন(2) লিখুন",
  EMailisinvalid: "ইমেল অবৈধ।",
  OpenDate: "খোলা হয়েছের তারিখ",
  BranchName: "শাখার নাম",
  EnterBranchName: "শাখার নাম লিখুন",
  EnterBranchCode: "শাখা কোড লিখুন",
  Norowsfoundforupdate: "আপডেট করার জন্য কোন সারি পাওয়া যায় নি",
  DoyouwanttoUpdateBranchMasterData:
    "আপনি কি শাখা মাস্টার ডেটা আপডেট করতে চান?",
  MobileNumber: "মোবাইল নম্বর",
  EnterMobileNumber: "মোবাইল নম্বর লিখুন",

  //OTP SMS Configuration
  OTPSMSConfiguration: "ওটিপি এসএমএস কনফিগারেশন",
  ActionCode: "অ্যাকশন কোড",
  EnterActionCode: "অ্যাকশন কোড লিখুন",
  ActionDescription: "অ্যাকশন বর্ণনা",
  EnterActionDescription: "অ্যাকশন বর্ণনা লিখুন",
  SMSText: "এসএমএস টেক্সট",
  EnterSMSText: "এসএমএস টেক্সট লিখুন",

  // Tenure Type Configuration
  TenureTypeConfiguration: "মেয়াদ প্রকার কনফিগারেশন",
  AccountType: "অ্যাকাউন্ট প্রকার",
  TransactionTypeDisplay: "লেনদেন প্রকাশ প্রকার",
  AccountTypesDisplay: "অ্যাকাউন্ট প্রকাশ প্রকার",
  TenureTypeReq: "মেয়াদ প্রকার*",
  TenureReq: "মেয়াদ*",
  Tenures: "মেয়াদ",
  EnterTenure: "মেয়াদ লিখুন",
  EffectiveFromReq: "প্রভাবী হতে*",

  // Email/SMS Template Configuration
  EmailSMSTemplateConfiguration: "ইমেল / এসএমএস টেমপ্লেট কনফিগারেশন",
  TranType: "লেনদেন প্রকার",
  EnterTranType: "লেনদেন প্রকার লিখুন",
  MailSubject: "ইমেল বিষয়",
  EnterMailSubject: "ইমেল বিষয় লিখুন",
  SenderMailID: "প্রেরক ইমেল আইডি",
  EnterSenderMailID: "প্রেরক ইমেল আইডি লিখুন",
  CCMailID: "সি.সি. মেইল আইডি",
  EnterCCMailID: "সি.সি. মেইল আইডি লিখুন",
  DisplaySenderName: "প্রেরকের নাম প্রদর্শন",
  EnterDisplaySenderName: "প্রেরকের নাম লিখুন",
  MailServer: "মেইল সার্ভার",
  SMS: "এসএমএস",
  Email: "ইমেইল",
  SorrythecontentyouaretryingtouploadmustbeinHTMLformat:
    "দুঃখিত, আপনি আপলোড করতে চেষ্টা করছেন সে সামগ্রীটি HTML ফরম্যাটে হতে হবে।",
  EmailConfiguration: "ইমেল কনফিগারেশন",
  Import: "আমদানি",
  EmailText: "ইমেল টেক্সট",
  EnterEmailText: "ইমেল টেক্সট লিখুন",
  Keys: "কী",
  NoteImportHTMLFile:
    "নোট: একটি HTML ফাইল আমদানি করতে, তা ইমেল টেক্সট বক্সে টেনে আনুন বা উপরের 'আমদানি' বোতামে ক্লিক করুন।",
  InvalidMailSenderMailID: "অবৈধ ইমেল প্রেরক ইমেল আইডি।",
  SMSConfiguration: "এসএমএস কনফিগারেশন",

  //Beneficiary Restriction Master
  BeneficiaryRestrictionMaster: "সুবিধাভোগী সীমাবদ্ধতা কনফিগারেশন",
  RestrictionType: "সীমাবদ্ধতা প্রকার",
  Value: "মান",
  BeneficiaryLabel: "সুবিধাভোগী লেবেল",
  AccountName: "অ্যাকাউন্ট নাম",
  EnterAccountName: "অ্যাকাউন্ট নাম লিখুন",
  ProductCode: "প্রোডাক্ট কোড",
  EnterProductCode: "প্রোডাক্ট কোড লিখুন",
  RoutingNumber: "রাউটিং নম্বর",
  EnterRoutingNumber: "রাউটিং নম্বর লিখুন",
  RecordAlreadyExists: "রেকর্ড ইতিমধ্যে বিদ্যমান।",

  // ATM Locator Master
  ATMLocatorMaster: "এটিএম লোকেটর মাস্টার",
  ATMLocation: "এটিএম লোকেশন",
  EnterATMLocation: "এটিএম লোকেশন লিখুন",
  Address1: "ঠিকানা 1",
  EnterAddress1: "ঠিকানা 1 লিখুন",
  Address2: "ঠিকানা 2",
  EnterAddress2: "ঠিকানা 2 লিখুন",
  Address3: "ঠিকানা 3",
  EnterAddress3: "ঠিকানা 3 লিখুন",
  PostalCode: "পোস্টাল কোড",
  EnterPostalCode: "পোস্টাল কোড লিখুন",
  ActiveStatus: "সক্রিয় অবস্থা",
  DoyouwanttoupdateATMLocatormasterdata:
    "আপনি কি এটিএম লোকেটার মাস্টার ডেটা আপডেট করতে চান?",

  //Screen Note Configuration
  ScreenNoteConfiguration: "স্ক্রিন নোট কনফিগারেশন",
  ScreenID: "স্ক্রিন আইডি",
  EnglishNote: "ইংরেজি নোট",
  BanglaNote: "বাংলা নোট",
  English: "ইংরেজি*",
  EnterEnglishMessage: "ইংরেজি বার্তা লিখুন",
  Bangla: "বাংলা",
  EnterBanglaMessage: "বাংলা বার্তা লিখুন",
  Translate: "অনুবাদ করুন",

  //Guessable Password Entry
  GuessablePasswordEntry: "অনুমান করা যায় পাসওয়ার্ড এন্ট্রি",
  GuessablePassword: "অনুমান করা যায় পাসওয়ার্ড",
  EnterGuessablePassword: "অনুমান করা যায় পাসওয়ার্ড লিখুন",

  // Banner Configuration
  BannerConfiguration: "ব্যানার কনফিগারেশন",
  BannerType: "ব্যানার প্রকার",
  BannerDescription: "ব্যানার বিবরণ",
  LoginID: "লগইন আইডি",
  EnterLoginID: "লগইন আইডি লিখুন",
  ChannelReq: "চ্যানেল*",
  Invaliddate: "অবৈধ তারিখ",
  ViewUploadHTML: "HTML দেখুন / আপলোড করুন",
  Htmltext: "HTML পাঠ",
  EnterHtmltext: "HTML পাঠ লিখুন",
  BannerNote:
    "নোট: HTML ফাইল আমদানি করতে, ইমেল টেক্সট বক্সে তা টেনে আনুন বা উপরের 'আমদানি' বোতামে ক্লিক করুন।",
  DropHere: "এখানে ফেলুন",
  DropHTMLFileHere: "এখানে HTML ফাইল ফেলুন",
  DisplayType: "ডিসপ্লে প্রকার",
  InvalidLoginID: "অবৈধ লগইন আইডি।",

  // Guideline File Configuration
  GuidelineFileConfiguration: "গাইডলাইন ফাইল কনফিগারেশন",
  UseCase: "ব্যবহারের ক্ষেত্র",
  UploadDate: "আপলোডের তারিখ",
  FileName: "ফাইলের নাম",
  EnterFileName: "ফাইলের নাম লিখুন",
  FileType: "ফাইলের ধরণ",
  Filesizeshouldbelessthan5MB: "ফাইলের আকার অধিকতম 5 এমবি হতে হবে।",
  PleaseSelectPDFFileonly: "দয়া করে কেবলমাত্র PDF ফাইল নির্বাচন করুন।",
  Nofilefoundtopreview: "পূর্বরূপের কোনও ফাইল পাওয়া যায়নি!",

  // FD Scheme Configuration
  FDSchemeConfiguration: "FD স্কিম কনফিগারেশন",
  FDAccounttype: "FD অ্যাকাউন্ট প্রকার",
  TenureTypeFinacle: "মেয়াদ প্রকার ফিনাকল",
  Tenure: "মেয়াদ",
  Renewal: "নবীকরণ",
  EnterRenewal: "নবীকরণ লিখুন",
  MaturityInst: "পরিপূর্ণতা ইন্স্ট।",
  EnterMaturityInst: "পরিপূর্ণতা ইন্স্ট লিখুন",
  NatureofAccount: "অ্যাকাউন্টের স্বভাব",
  EnterNatureofAccount: "অ্যাকাউন্টের স্বভাব লিখুন",
  TenureTypeRate: "মেয়াদ প্রকার হার",
  EnterTenureTypeRate: "মেয়াদ প্রকার হার লিখুন",
  CCY: "সিসি ওয়াই.",
  EnterCCY: "সিসি ওয়াই লিখুন",
  SchemeDescription: "স্কিম বর্ণনা",
  EnterSchemeDescription: "স্কিম বর্ণনা লিখুন",
  TDModAmount: "টি.ডি মড পরিমাণ",
  EnterTDModAmount: "টি.ডি মড পরিমাণ লিখুন",
  SampleFileDownload: "নমুনা ফাইল ডাউনলোড",
  FdAccountType: "এফডি অ্যাকাউন্ট প্রকার",
  EnterFdAccountType: "এফডি অ্যাকাউন্ট প্রকার লিখুন",
  DoyouwanttoUpdateFDSchemeMasterData: "আপডেট করতে চান FD স্কিম মাস্টার ডেটা?",

  // Parameter Master
  Parameter: "প্যারামিটার",
  ParameterMaster: "প্যারামিটার মাস্টার",
  DataType: "ডেটা প্রকার",
  GlobalLevel: "গ্লোবাল স্তর",
  HOLevel: "এইচও স্তর",
  EnterValue: "মান লিখুন",
  ParameterConfirmation: "প্যারামিটার নিশ্চিতকরণ",
  NewParameterValue: "নতুন প্যারামিটার মান",
  OldParameterValue: "পুরানো প্যারামিটার মান",
  NewDatatype: "নতুন ডেটা প্রকার",
  OldDatatype: "পুরানো ডেটা প্রকার",

  // Miscellaneous Master
  MiscellaneousMaster: "বিবিধ মাস্টার",
  CategoryCode: "বিভাগ কোড",
  EnterCategoryCode: "বিভাগ কোড লিখুন",
  DataValue: "ডেটা মান",
  EnterDataValue: "ডেটা মান লিখুন",
  DisplayValue: "ডিসপ্লে মান",
  EnterDisplayValue: "ডিসপ্লে মান লিখুন",

  // User Block Configuration
  UserBlockConfiguration: "ব্যবহারকারী ব্লক কনফিগারেশন",
  ConfigType: "কনফিগারেশন প্রকার",
  FailAttempt: "ব্যর্থ প্রচেষ্টা",
  MinutesOfBlock: "ব্লকের মিনিট",
  EnterMinutesOfBlock: "ব্লকের মিনিট লিখুন",
  AutoRelease: "অটো রিলিজ",
  EnterNoOfFailAttempt: "ব্যর্থ প্রচেষ্টার সংখ্যা লিখুন",
  OldFailAttempt: "পুরানো ব্যর্থ প্রচেষ্টা",
  OldMinutesOfBlock: "পুরানো ব্লকের মিনিট",
  UserBlockConfigurationConfirmation: "ব্যবহারকারী ব্লক কনফিগারেশন নিশ্চিতকরণ",

  //Application Review User Master
  ApplicationReviewUserMaster: "অ্যাপ্লিকেশন পর্যালোচনা ব্যবহারকারী মাস্টার",
  LoginName: "লগইন নাম",
  TestLoginID: "টেস্ট লগইন আইডি",
  ReviewLoginName: "পর্যালোচনা লগইন নাম",
  LatestVersion: "সর্বশেষ সংস্করণ",
  EnterLatestAppVersion: "সর্বশেষ অ্যাপ সংস্করণ লিখুন",
  ExpiryDate: "মেয়াদ উত্তীর্ণের তারিখ",
  TestUserLastLoginDate: "টেস্ট ব্যবহারকারীর শেষ লগইনের তারিখ",
  EnterTestLoginID: "টেস্ট লগইন আইডি লিখুন",
  EnterReviewLoginName: "পর্যালোচনা লগইন নাম লিখুন",
  EnterLatestVersion: "সর্বশেষ সংস্করণ লিখুন",
  Spaceatthebeginningisnotallowed: "শুরুতে স্পেস অনুমোদিত নয়।",
  EnteraproperMobileAppVersion: "একটি যথার্থ মোবাইল অ্যাপ সংস্করণ লিখুন।",
  Pastdateisnotallowed: "পূর্বের তারিখ অনুমোদিত নয়.",
  EnterTestUserLastLoginDate: "টেস্ট ব্যবহারকারীর শেষ লগইনের তারিখ লিখুন",

  //Validation Message Master
  ValidationMessageMaster: "যাচাইকরণ বার্তা মাস্টার",
  MessageCode: "বার্তা কোড",
  EnglishMessage: "ইংরেজি বার্তা",
  BanglaMessage: "বাংলা বার্তা",
  EnglishLan: "ইংরেজি",

  //Card BIN Image Configuration
  CardBINImageConfiguration: "কার্ড BIN চিত্র কনফিগারেশন",
  CardBin: "কার্ড বিন",
  AllowBanglaQR: "বাংলা QR অনুমোদিত",
  CardImage: "কার্ড ইমেজ",
  UserStatus: "ব্যবহারকারী স্থিতি",
  CardBinImageUpload: "কার্ড বিন ইমেজ আপলোড",
  CardBinNumber: "কার্ড বিন নম্বর",
  EnterCardBinNumber: "কার্ড বিন নম্বর লিখুন",
  Imagesizeshouldbelessthan5MB: "ইমেজের আকার 5 এমবি-এর কম হতে হবে।",
  PleaseSelectValidFormat: "দয়া করে বৈধ ফরম্যাট নির্বাচন করুন।",
  ClicktouploadtheCardImage: "কার্ড ইমেজ আপলোড করতে ক্লিক করুন",
  UploadCardImage: "কার্ড ইমেজ আপলোড করুন",
  ClickontheCardImageboxtouploadImage:
    "ইমেজ আপলোড করতে কার্ড ইমেজ বক্সে ক্লিক করুন।",
  MaximumImageSizeshouldbe5MB: "সর্বোচ্চ ইমেজ আকার 5 এমবি হতে হবে।",
  ImageformatshouldbeJPEGorPNG: "ইমেজ ফরম্যাট JPEG অথবা PNG হতে হবে।",

  // MS Monitoring Master

  MSMonitoringMaster: "এমএস মনিটরিং মাস্টার",
  ServiceID: "সেবা আইডি",
  ActiveInstance: "সক্রিয় ইনস্ট্যান্স",
  MSInstanceInformations: "এমএস ইনস্ট্যান্স তথ্য",
  InstanceID: "ইনস্ট্যান্স আইডি",
  PropertiesList: "বৈশিষ্ট্য তালিকা",
  Properties: "বৈশিষ্ট্য",
  MicroServiceList: "মাইক্রোসার্ভিস তালিকা",
  InstanceStatus: "ইনস্ট্যান্স স্থিতি",
  UpdateStatus: "আপডেট স্থিতি",
  APIResponse: "এপিআই সার্ভার প্রতিক্রিয়া",

  //Service wise Mobile Number Validation Template Mapping
  ServiceWiseMobileNumberValidationMaster:
    "পরিষেবা অনুসারে মোবাইল নম্বর যাচাইকরণ মাস্টার",
  TemplateName: "টেম্পলেট নাম",
  ServiceWiseMobileNumberValidationConfirmation:
    "সেবা অনুযায়ী মোবাইল নম্বর যাচাই নিশ্চিতকরণ",

  //IDTP Charge Configuration
  MSPropertiesConfiguration: "এমএস বৈশিষ্ট্য কনফিগারেশন",
  ApplicationName: "অ্যাপ্লিকেশন নাম",
  ProfileName: "প্রোফাইল নাম",
  Label: "লেবেল",
  AreyousuretodeleteselectedMobileNumberValidationTemplate:
    "আপনি কি নিশ্চিত যে নির্বাচিত মোবাইল নম্বর যাচাই টেম্পলেটটি মুছতে চান?",
  Key: "কী",
  EnterKey: "কী লিখুন",
  NoteOne: "1. *-মানে * পর্যন্ত কী মান প্রতিস্থাপন করুন। EX.ACCOUNT=*{' '}",
  NoteTwo:
    "2. যদি খালি হয় তবে কী মানটি ফাঁকা স্ট্রিং দিয়ে প্রতিস্থাপন করুন। EX.accountNumber={' '}",
  NoteThree:
    "3. যদি ফর্ম্যাট নির্ধারিত হয় তবে সিস্টেম ফর্ম্যাট মিলিয়ে প্রদত্ত ফর্ম্যাট অনুযায়ী মাস্ক মান এবং মাস্ক মানটি করবে, তবে ফর্ম্যাট লেংথ অবশ্যই কী মান লেংথের সমান হতে হবে। যদি ফর্ম্যাট মানটি মানের লেংথের সাথে মেলে না তাহলে কোনও মাস্কিং করা হবে না। EX.$[1234******123,1234******123578]{' '}",
  NoteFour:
    "4. যদি এখানে নির্দিষ্ট কী নাম থাকে যা JSON অবজেক্ট / JSON অ্যারে হিসাবে মান ধারণ করে, তবে মানটি '''' দিয়ে প্রতিস্থাপন করা হবে।{' '}",

  // Virtual Card Image Configuration
  CardImageConfiguration: "কার্ড ইমেজ কনফিগারেশন",
  CardImageConfirmation: "কার্ড ইমেজ কনফিগারেশন নিশ্চিতকরণ",
  ImageID: "ইমেজ আইডি",
  EnterImageID: "ইমেজ আইডি লিখুন",
  CardImageUpload: "কার্ড ইমেজ আপলোড",

  //Web Rerouting Configuration
  WebReroutingConfiguration: "ওয়েব পুনঃরূটিং কনফিগারেশন",
  ActionMenu: "অ্যাকশন মেনু",
  PopupStatus: "পপআপ স্ট্যাটাস",
  LoginStatus: "লগইন স্ট্যাটাস",
  LabelEnglish: "লেবেল (ইংরেজি)",
  EnterEnglishLanguageLabel: "ইংরেজি ভাষার লেবেল লিখুন",
  LabelLocalLanguage: "লেবেল (স্থানীয় ভাষা)",
  EnterLocalLanguageLabel: "স্থানীয় ভাষার লেবেল লিখুন",
  PleaseentervalidURL: "দয়া করে বৈধ URL লিখুন।",
  PopupMessageEnglish: "পপআপ বার্তা (ইংরেজি)",
  EnterEnglishLanguagePopupMessage: "ইংরেজি ভাষার পপআপ বার্তা লিখুন",
  PopupMessageLocalLanguage: "পপআপ বার্তা (স্থানীয় ভাষা)",
  EnterLocalLanguagePopupMessage: "স্থানীয় ভাষার পপআপ বার্তা লিখুন",
  ServiceCode: "সেবা কোড",
  EnterServiceCode: "সেবা কোড লিখুন",
  APIPassword: "এপিআই পাসওয়ার্ড",
  EnterAPIPassword: "এপিআই পাসওয়ার্ড লিখুন",
  APIUserID: "এপিআই ব্যবহারকারী আইডি",
  EnterAPIUserID: "এপিআই ব্যবহারকারী আইডি লিখুন",
  URL: "ইউআরএল",
  EnterURL: "ইউআরএল লিখুন",
  WebReroutingConfirmation: "ওয়েব পুনঃরূটিং নিশ্চিতকরণ",
  MenuIcon: "মেনু আইকন",
  ClicktouploadtheMenuIcon: "মেনু আইকন আপলোড করতে ক্লিক করুন",
  UploadMenuIcon: "মেনু আইকন আপলোড করুন",
  ClickontheMenuIconboxtouploadIcon:
    "আইকন আপলোড করতে মেনু আইকন বক্সে ক্লিক করুন।",
  MaximumIconSizeshouldbe5MB: "সর্বাধিক আইকন আকার 5 এমবি হতে হবে।",
  IconformatshouldbeJPEGorPNG: "আইকন ফর্মেট হতে হবে JPEG বা PNG।",

  //Payment Gateway Merchant Master
  PaymentGatewayMerchantMaster: "পেমেন্ট গেটওয়ে মার্চেন্ট মাস্টার",
  PaymentGatewayMerchantNameReq: "পেমেন্ট গেটওয়ে মার্চেন্ট নাম*",
  EnterPaymentGatewayMerchantName: "পেমেন্ট গেটওয়ে মার্চেন্ট নাম লিখুন",

  //Merchant Onboarding Confirmation
  MerchantOnboardingConfirmation: "মার্চেন্ট অনবোর্ডিং নিশ্চিতকরণ",
  MerchantOnboardingConfiguration: "মার্চেন্ট অনবোর্ডিং কনফিগারেশন",
  GateWayPasswordValidation:
    "গেটওয়ে পাসওয়ার্ডটি বর্ণানুক্রমিক এবং কমপ্লেক্স হতে হবে এবং অন্তত একটি বিশেষ অক্ষর, একটি ছোট হাতের অক্ষর, একটি বড় হাতের অক্ষর ছাড়া যেকোনো স্থানে কোনও স্পেস ছাড়া।",
  PerTransactionLimit: "প্রতি লেনদেনের সীমা",
  EnterPerTransactionLimit: "প্রতি লেনদেনের সীমা লিখুন",
  GatewayEmail: "গেটওয়ে ইমেল",
  EnterGatewayEmail: "গেটওয়ে ইমেল লিখুন",
  InvalidMailGatewayEmail: "অকার্যকর মেইল গেটওয়ে ইমেল।",
  PercentageofVAT: "ভ্যাটের শতাংশ",
  EnterPercentageofVAT: "ভ্যাটের শতাংশ লিখুন",
  ToAccountNumber: "অ্যাকাউন্ট নম্বরে প্রেরণ",
  EnterToAccountNumber: "অ্যাকাউন্ট নম্বর লিখুন",
  GatewayUsername: "গেটওয়ে ব্যবহারকারীনাম",
  GatewayPassword: "গেটওয়ে পাসওয়ার্ড",
  EnterGatewayPassword: "গেটওয়ে পাসওয়ার্ড লিখুন",
  PleaseEnterURL: "দয়া করে ইউআরএল লিখুন।",

  // PGW Merchant Users
  PGWMerchantUsers: "PGW মার্চেন্ট ব্যবহারকারী",
  UserRole: "ব্যবহারকারী ভূমিকা",
  PGWMerchantUsersConfirmation: "PGW মার্চেন্ট ব্যবহারকারী নিশ্চিতকরণ",
  PGWMerchantUserCreation: "PGW মার্চেন্ট ব্যবহারকারী সৃষ্টি",
  GatewayNamePID: "গেটওয়ে নাম (PID)",
  PleaseentervalidIPAddress: "দয়া করে বৈধ আইপি ঠিকানা লিখুন।",
  IPAddress: "আইপি ঠিকানা",
  EnterIPAddress: "আইপি ঠিকানা লিখুন।",
  EmailIDisinvalid: "ইমেল আইডি অবৈধ",
  GatewayName: "গেটওয়ে নাম",
  ConfirmationStatus: "নিশ্চিতকরণ অবস্থা",

  //Mobile Number Validation Template
  MobileNumberValidationTemplate: "মোবাইল নম্বর যাচাই টেমপ্লেট",
  MobileNoLengthReq: "মোবাইল নম্বরের দৈর্ঘ্য*",
  EnterMobileNoLength: "মোবাইল নম্বরের দৈর্ঘ্য লিখুন",
  MobileNoStartFrom: "মোবাইল নম্বর শুরু হবে",
  EnterMobileNoStartFrom: "মোবাইল নম্বর শুরু লিখুন",
  DescriptionReq: "বর্ণনা*",

  //Dynamic Biller Deletion Request Confirmation
  DynamicBillerDeletionRequestConfirmation:
    "ডায়নামিক বিলার মোছা অনুরোধের অনুমোদন",
  DynamicBillerConfirmation: "ডায়নামিক বিলার নিশ্চিতকরণ",
  DynamicBillerConfiguration: "ডায়নামিক বিলার কনফিগারেশন",
  CategoryID: "বিভাগ আইডি",
  EnterCategoryID: "বিভাগ আইডি লিখুন",
  SubCategoryID: "উপবিভাগ আইডি",
  EnterSubCategoryID: "উপবিভাগ আইডি লিখুন",
  BillerID: "বিলার আইডি",
  EnterBillerID: "বিলার আইডি লিখুন",
  BilleName: "বিলার নাম",
  EnterBilleName: "বিলার নাম লিখুন",
  SubCategoryName: "উপবিভাগ নাম",
  CategoryName: "বিভাগ নাম",
  BillerDescription: "বিলার বর্ণনা",
  SubCategoryDescription: "উপবিভাগ বর্ণনা",
  CategoryDescription: "বিভাগ বর্ণনা",
  BillerInfoURL: "বিলার তথ্য URL",
  BillerPaymentURL: "বিলার পেমেন্ট URL",
  Refresh: "রিফ্রেশ",
  ScreenNotes: "স্ক্রিন নোট",
  FieldOptions: "ফিল্ড অপশন",
  Options: "অপশন",
  BillerDetails: "বিলার বিবরণ",
  Doyouwanttoupdateselectedbillerdata:
    "আপনি কি নির্বাচিত বিলার তথ্য আপডেট করতে চান?",
  RefreshDynamicBillerConfiguration: "ডায়নামিক বিলার কনফিগারেশন রিফ্রেশ",
  DynamicBillerScreenNotes: "ডায়নামিক বিলার স্ক্রিন নোট",
  Language: "ভাষা",
  ScreenMessage: "স্ক্রিন বার্তা",
  EnterScreenMessage: "স্ক্রিন বার্তা লিখুন",
  FieldName: "ফিল্ড নাম",
  FieldType: "ফিল্ড প্রকার",
  Required: "প্রয়োজনীয়",
  Datatype: "ডেটা প্রকার",
  MinimumValue: "ন্যূনতম মান",
  MaximumValue: "সর্বোচ্চ মান",
  LabelEnglish1: "লেবেল ইংরেজি",
  LabelBangla: "লেবেল বাংলা",
  DefaultValue: "ডিফল্ট মান",
  TextAlign: "টেক্সট সাজান",
  Placeholder: "প্লেসহোল্ডার",
  ValidationRegex: "যাচাই রেগুলার এক্সপ্রেশন",
  IsBeneficiaryField: "উপকারপ্রাপ্ত ফিল্ড?",
  RequireForBillInfo: "বিল তথ্যের জন্য প্রয়োজন?",
  DisplaySequence: "ডিসপ্লে ক্রম",
  IspayableAmount: "প্রদানযোগ্য পরিমাণ?",
  IsBillNumber: "বিল নম্বর?",
  IsFromAccountField: "অ্যাকাউন্ট ফিল্ড থেকে?",
  IsReadonlyField: "শোনা মাত্র ফিল্ড?",
  OptionsName: "অপশন নাম",
  OptionsValue: "অপশন মান",
  ParameterKeys: "প্যারামিটার কী",
  DynamicBillerURLs: "ডায়নামিক বিলার ইউআরএল",
  BillerFields: "বিলার ফিল্ড",
  BillInfoParameters: "বিল তথ্য প্যারামিটার",
  BillPaymentParameters: "বিল পেমেন্ট প্যারামিটার",
  BillerName: "বিলার নাম",
  DynamicBillerAccountsChargeConfirmation:
    "ডায়নামিক বিলার অ্যাকাউন্ট / চার্জ নিশ্চিতকরণ",
  FinaclePoolAccount: "ফিনেকল পুল অ্যাকাউন্ট",
  EnterFinaclePoolAccount: "ফিনেকল পুল অ্যাকাউন্ট লিখুন",
  AbabilPoolAccount: "আবাবিল পুল অ্যাকাউন্ট",
  EnterAbabilPoolAccount: "আবাবিল পুল অ্যাকাউন্ট লিখুন",
  DynamicBillerChargeConfiguration: "ডায়নামিক বিলার চার্জ কনফিগারেশন",
  SubCategoryImage: "সাব বিভাগ ইমেজ",
  BillerImage: "বিলার ইমেজ",
  NoteDoubleclickontheImageboxtouploadanewImage:
    "নোট: একটি নতুন ইমেজ আপলোড করতে ইমেজ বক্সে ডাবল-ক্লিক করুন।",

  //Bank Master
  BankMaster: "ব্যাংক মাস্টার",
  BankCode: "ব্যাংক কোড",
  EnterBankCode: "ব্যাংক কোড লিখুন",
  NewDistrictCode: "নতুন জেলা কোড",
  NPSBBankCode: "NPSB ব্যাংক কোড",
  EnterNPSBBankCode: "NPSB ব্যাংক কোড লিখুন",
  BankName: "ব্যাংকের নাম",
  EnterBankName: "ব্যাংকের নাম লিখুন",
  NPSB: "NPSB",
  BEFTN: "BEFTN",
  RTGS: "RTGS",
  ROWTYPE: "সারি প্রকার",
  NPSBENABLED: "NPSB সক্ষম",
  BEFTNENABLED: "BEFTN সক্ষম",
  RTGSENABLED: "RTGS সক্ষম",
  Pleaseselectrecords: "রেকর্ড নির্বাচন করুন।",
  Doyouwanttodeletetheselectedrecords: "আপনি কি নির্বাচিত রেকর্ড মুছতে চান?",
  Pleaseselectoneusertogetthedetails:
    "বিস্তারিত পেতে একজন ব্যবহারকারী নির্বাচন করুন।",
  UpdateServiceStatus: "পরিষেবার অবস্থা আপডেট করুন",
  BankServiceStatusTitle: "ব্যাঙ্ক পরিষেবা স্ট্যাটাস আপডেট",
  BankServiceStatusCountNote: "নির্বাচিত ব্যাংক: ",
  BankServiceStatusNote:
    "দ্রষ্টব্য: সমস্ত নির্বাচিত ব্যাঙ্ক জুড়ে আপডেট করার জন্য দয়া করে পরিষেবা এবং স্থিতি চয়ন করুন৷",
  BankServiceStatusUpdateMsg:
    "আপনি কি নিশ্চিত যে আপনি সমস্ত নির্বাচিত ব্যাঙ্কে {0} {1} পরিষেবা চান?",
  DoyouwanttoUpdateBankMasterData:
    "আপনি কি ব্যাংক মাস্টার ডেটা আপডেট করতে চান?",

  // MFS Configuration

  MFSConfiguration: "MFS কনফিগারেশন",
  MFSService: "MFS সেবা",
  MFSID: "MFS আইডি",
  EnterMFSID: "MFS আইডি লিখুন",
  MFSName: "MFS নাম",
  EnterMFSName: "MFS নাম লিখুন",
  MaximunDailyLimit: "সর্বোচ্চ দৈনিক সীমা",
  MFSLabelEnglish: "MFS লেবেল (ইংরেজি)",
  EnterMFSEnglishLanguageLabel: "ইংরেজি ভাষার মধ্যে MFS লেবেল লিখুন",
  MFSLabelLocal: "MFS লেবেল (স্থানীয়)",
  EnterMFSLocalLanguageLabel: "স্থানীয় ভাষায় MFS লেবেল লিখুন",
  TranCode: "লেনদেন কোড",
  Perdaymaxaddmoneyinbeneficiary: "প্রতিদিন মোট অ্যাড মানি মানি মধ্যে সর্বাধিক",
  EnterPerdaymaxaddmoneyinbeneficiary:
    "প্রতিদিন মোট অ্যাড মানি মানি মধ্যে সর্বাধিক লিখুন",
  MFSConfigurationConfirmation: "MFS কনফিগারেশন নিশ্চিতকরণ",
  MFSIcon: "MFS আইকন",

  //From Source Key Value Configuration
  FromSourceKeyValueConfiguration: "সোর্স কী মান কনফিগারেশন থেকে",
  Services: "সেবাগুলি",
  DescriptionisAlreadyenteredatLine:
    "বর্ণনা ইতিমধ্যেই {0} লাইনে প্রবেশ করানো হয়েছে",
  AllowDisallowReq: "অনুমোদন/নিষেধ*",
  ResponseKeyValue: "প্রতিক্রিয়া কী মান",
  ResponseKey: "প্রতিক্রিয়া কী",
  ResponseKeyValueReq: "প্রতিক্রিয়া কী মান*",
  EnterResponseKeyValue: "প্রতিক্রিয়া কী মান লিখুন",

  //Card Activate/Deactivate Status Configuration
  CardActivateDeactivateStatusConfiguration:
    "কার্ড সক্রিয়/নিষ্ক্রিয় অবস্থা কনফিগারেশন",
  CardStatus: "কার্ড অবস্থা",
  OperationType: "অপারেশন প্রকার",
  StatusValue: "অবস্থা মান",
  EnterStatusValue: "অবস্থা মান লিখুন",
  EnableStatusReq: "সক্রিয় অবস্থা*",
  EnablestatusisAlreadyenteredatLine:
    "সক্ষম স্থিতি ইতিমধ্যে লাইন {0} এ প্রবেশ করানো হয়েছে",
  StatusValueReq: "অবস্থা মান*",
  StatusValueisAlreadyenteredatLine:
    "স্ট্যাটাস মান ইতিমধ্যেই লাইন {0} এ প্রবেশ করানো হয়েছে",

  // Product Display Name Configuration
  ProductDisplayNameConfiguration: "পণ্য প্রদর্শন নাম কনফিগারেশন",
  DisplayName: "প্রদর্শন নাম",
  Enterdisplayname: "প্রদর্শন নাম লিখুন",
  CompanyCode: "কোম্পানি কোড",
  SchemeCodeCardBINReq: "স্কিম কোড/কার্ড BIN*",
  EnterschemecodeCarBINno: "স্কিম কোড/কার্ড BIN নাম্বার লিখুন",
  SchemeCodeCardBINNoisAlreadyenteredatLine:
    "স্কিম কোড/কার্ড বিআইএন নম্বর ইতিমধ্যেই {0} লাইনে প্রবেশ করানো হয়েছে",
  SchemeNameReq: "স্কিম নাম*",
  Enterschemename: "স্কিম নাম লিখুন",

  //Application Version Master
  ApplicationVersionMaster: "অ্যাপ্লিকেশন সংস্করণ মাস্টার",
  DeviceOS: "ডিভাইস অপারেটিং সিস্টেম",
  Version: "সংস্করণ",
  PopupMessage: "পপআপ বার্তা",
  ForceUpdate: "বাধ্যতামূলক আপডেট",
  EnterVersion: "সংস্করণ লিখুন",

  // Page Content Configuration
  PageContentConfiguration: "পৃষ্ঠার বিষয়বস্তু কনফিগারেশন",
  DetailsID: "বিস্তারিত আইডি",
  EnterDetailsID: "বিস্তারিত আইডি লিখুন",
  LanguageCode: "ভাষা কোড",
  LanguageID: "ভাষা আইডি",
  EnterLanguageID: "ভাষা আইডি লিখুন",
  DetailData: "বিস্তারিত ডেটা",
  EnterDetailData: "বিস্তারিত ডেটা লিখুন",

  // Virtual Card Product Type Configuration
  VirtualCardProductTypeConfiguration:
    "ভার্চুয়াল কার্ড পণ্য প্রকার কনফিগারেশন",
  ProductType: "পণ্যের প্রকার",
  CardProductBIN: "কার্ড পণ্য BIN",
  EnterCardProductBIN: "কার্ড পণ্য BIN লিখুন",
  ProductID: "পণ্য আইডি",
  EnterProductID: "পণ্য আইডি লিখুন",
  ProductName: "পণ্যের নাম",
  EnterProductName: "পণ্যের নাম লিখুন",
  VerifiedBy: "যাচাইকৃত করেছে",
  VerifiedDate: "যাচাইকৃত তারিখ",
  VirtualCardProductTypeConfigurationConfirmation:
    "ভার্চুয়াল কার্ড পণ্য প্রকার কনফিগারেশন নিশ্চিতকরণ",
  CardLimit: "কার্ড সীমা",
  EnterCardLimit: "কার্ড সীমা লিখুন",
  FinancialProfile: "আর্থিক প্রোফাইল",
  EnterFinancialProfile: "আর্থিক প্রোফাইল লিখুন",
  LimitCurrency: "সীমা মুদ্রা",
  LimitGroup: "সীমা গ্রুপ",
  EnterLimitGroup: "সীমা গ্রুপ লিখুন",
  RMCode: "আরএম কোড",
  EnterRMCode: "আরএম কোড লিখুন",
  AllowInIntroductionPage: "পরিচিতিতে অনুমোদন",
  VirtualCardProductTypeDetails: "ভার্চুয়াল কার্ড পণ্য প্রকার বিস্তারিত",
  SchemeCodeReq: "স্কিম কোড*",
  SchemecodeandConstitutionalreadyexistsatline:
    "স্কিম কোড এবং সংবিধান ইতিমধ্যে লাইন {0} এ বিদ্যমান",
  ConstitutionReq: "সংবিধান*",
  EnterConstitution: "সংবিধান লিখুন",

  //Customer Wise Limit Modification Confirmation
  CustomerWiseLimitModificationConfirmation:
    "গ্রাহক অনুযায়ী সীমা পরিবর্তন নিশ্চিতকরণ",
  CustomerName: "গ্রাহকের নাম",
  UserWiseLimitConfirmation: "ব্যবহারকারী অনুযায়ী সীমা নিশ্চিতকরণ",
  UserWiseLimitConfiguration: "ব্যবহারকারী অনুযায়ী সীমা কনফিগারেশন",
  Retry: "পুনরায় চেষ্টা করুন",
  CustomerDetails: "গ্রাহকের বিবরণ",
  CardMinimumAmt: "কার্ড ন্যূনতম পরিমাণ",
  MaximumAmountReq: "সর্বোচ্চ পরিমাণ*",
  MinimumAmountReq: "ন্যূনতম পরিমাণ*",
  DailyLimitReq: "প্রতিদিনের সীমা*",
  Thistypealreadyexists: "এই প্রকারটি ইতিমধ্যে বিদ্যমান।",

  // Customer Activation
  CustomerActivation: "গ্রাহক সক্রিয়করণ",
  ActivationUsing: "ব্যবহার সক্রিয়করণ",
  SelectOption: "অপশন নির্বাচন করুন",
  ClientID: "ক্লায়েন্ট আইডি",
  EnterClientID: "ক্লায়েন্ট আইডি লিখুন",
  CardNumber: "কার্ড নম্বর",
  EnterCardNumber: "কার্ড নম্বর লিখুন",
  RegWith: "সাথে নিবন্ধন",
  RegAccount: "নিবন্ধন হিসাব",
  Name: "নাম",
  BirthDate: "জন্ম তারিখ",
  EMailAddress: "ই-মেইল ঠিকানা",
  NoteAfterconfirmationtemporarypasswordwillbesenttotheregisteredmobilenumber:
    "নোট: নিশ্চিতকরণের পরে সাম্প্রতিক পাসওয়ার্ডটি নিবন্ধিত মোবাইল নম্বরে প্রেরিত হবে।",
  FetchDetails: "বিস্তারিত প্রাপ্ত করুন",
  AccountCardNumber: "হিসাব/কার্ড নম্বর",
  CustomerID: "গ্রাহক আইডি",
  EnterCustomerID: "গ্রাহক আইডি লিখুন",
  Constitution: "সংবিধান",
  AccountTypeName: "হিসাবের ধরনের নাম",
  Gender: "লিঙ্গ",
  FatherName: "পিতার নাম",
  MotherName: "মাতার নাম",
  LinkedAccount: "সংযুক্ত হিসাব",
  FullName: "পুরো নাম",
  TINNumber: "টিআইএন নম্বর",
  NationalID13Digit: "জাতীয় আইডি ১৩ অংক",
  ModeOfOperation: "অপারেশনের মোড",
  Nationality: "জাতীয়তা",
  NationalID: "জাতীয় আইডি",
  IdentificationNumber: "সনাক্তকরণ নম্বর",
  CustomerCardDetails: "গ্রাহক কার্ডের বিবরণ",
  CardDetails: "কার্ডের বিবরণ",
  CustomerActivationConfirmation: "গ্রাহক সক্রিয়করণ নিশ্চিতকরণ",
  RequestDate: "অনুরোধ তারিখ",
  RequestNumber: "অনুরোধ নম্বর",
  RequestBy: "অনুরোধকারী",
  accountCardType: "অ্যাকাউন্ট কার্ড/টাইপ",

  // Customer Searching
  CustomerSearching: "গ্রাহক অনুসন্ধান",
  GetDetails: "বিস্তারিত প্রাপ্ত করুন",
  ClientIDCBNumber: "ক্লায়েন্ট আইডি/সিবি নম্বর",
  TIN: "টিআইএন",
  NoteAllFieldscontainawildsearchfacility:
    "নোট: সমস্ত ক্ষেত্রে একটি ওয়াইল্ড অনুসন্ধান সুবিধা রয়েছে।",
  Pleaseenteravalidemailaddress: "দয়া করে একটি বৈধ ইমেল ঠিকানা লিখুন",
  PrimaryAccountCardNumber: "প্রাথমিক অ্যাকাউন্ট/কার্ড নম্বর",
  PrimaryCBNumber: "প্রাথমিক সিবি নম্বর",
  PrimarySource: "প্রাথমিক উৎস",
  AdminRemarks: "অ্যাডমিন মন্তব্য",
  AuthFlag: "অনুমোদনের পতাকা",
  LimitModification: "সীমা পরিবর্তন",
  CurrentRelationshipData: "বর্তমান সম্পর্কের ডেটা",
  Restrict: "সীমিত করুন",
  Unlock: "আনলক",
  Remarks: "মন্তব্য",
  EnterRemarks: "মন্তব্য লিখুন",
  TransactionTypeReq: "লেনদেনের ধরণ*",
  Dailylimitshouldbelessthanweeklylimit:
    "দৈনিক সীমা সাপ্তাহিক সীমার চেয়ে কম হতে হবে।",
  DailylimitshouldbelessthanMonthlylimit:
    "দৈনিক সীমা মাসিক সীমার চেয়ে কম হতে হবে।",
  WeeklyLimitshouldbemorethenDailyLimit:
    "সাপ্তাহিক সীমা দৈনিক সীমার চেয়ে অধিক হতে হবে।",
  PasswordReset: "পাসওয়ার্ড রিসেট",
  CBNumber: "সিবি নম্বর",
  IdentificationNo: "সনাক্তকরণ নম্বর",
  DoyouwanttoPasswordReset: "আপনি পাসওয়ার্ড রিসেট করতে চান?",
  RefreshCustomerRelationshipData: "গ্রাহক সম্পর্কের ডেটা রিফ্রেশ করুন",
  FetchData: "ডেটা পেতে",
  PrimaryAccountCard: "প্রাথমিক অ্যাকাউন্ট/কার্ড",
  LastLoginDate: "শেষ লগইনের তারিখ",
  PasswordChangeDate: "পাসওয়ার্ড পরিবর্তনের তারিখ",
  RestrictionRemarks: "সীমাবদ্ধতা মন্তব্য",
  UnlockingRemarks: "আনলকিং মন্তব্য",
  UpdateData: "আপডেট ডেটা",

  // Password Reset Confirmation
  PasswordResetConfirmation: "পাসওয়ার্ড রিসেট নিশ্চিতকরণ",
  AcceptRemarks: "মন্তব্য গ্রহণ করুন",
  RejectionRemarks: "প্রত্যাখ্যান মন্তব্য",

  // Primary Identifier Change
  PrimaryIdentifierChange: "প্রাথমিক সনাক্তকরণ পরিবর্তন",
  Search: "অনুসন্ধান",
  SignUpWith: "সাইন আপ সাথে",
  PrimaryIdentifierChangeConfirmation:
    "প্রাথমিক সনাক্তকরণ পরিবর্তনের নিশ্চিতকরণ",
  OldPrimarySource: "পুরাতন প্রাথমিক উৎস",
  NewPrimarySource: "নতুন প্রাথমিক উৎস",
  OldCBNumber: "পুরাতন সিবি নম্বর",
  NewCBNumber: "নতুন সিবি নম্বর",
  OldCardAccountNumber: "পুরাতন কার্ড/অ্যাকাউন্ট নম্বর",
  NewCardAccountNumber: "নতুন কার্ড/অ্যাকাউন্ট নম্বর",

  SetAsPrimary: "প্রাথমিক হিসাবে সেট করুন",
  DoyouwanttosetthisaccountcardasaPrimaryIdentifier:
    "আপনি কি এই অ্যাকাউন্ট/কার্ডটি প্রাথমিক সনাক্তকারী হিসাবে সেট করতে চান?",

  //CIB Loan Request Check
  CIBLoanRequestCheck: "সিআইবি ঋণ অনুরোধ পরীক্ষা",
  LoanRequestCheck: "ঋণ অনুরোধ পরীক্ষা",
  FileNumber: "ফাইল নম্বর",
  ApplicantName: "আবেদনকারীর নাম",
  TDAccount: "টি-ডি অ্যাকাউন্ট",
  LoanAmount: "ঋণের পরিমাণ",
  EMIAmount: "ইএমআই পরিমাণ",
  LockBy: "লক করুন দ্বারা",
  CIBCalculationView: "সিআইবি হিসাব | দেখুন",
  AppliedLoanamount: "প্রযোজ্য ঋণের পরিমাণ",
  ProposedEMIamount: "প্রস্তাবিত ইএমআই পরিমাণ",
  AppliedTenor: "প্রযোজ্য অবধি",
  DOB: "জন্ম তারিখ",
  DistrictofBirth: "জন্মের জেলা",
  NID: "জাতীয় পরিচয় নম্বর",
  ETINNumber: "ই-টিইএন নম্বর",
  SmartCardNumber: "স্মার্ট কার্ড নম্বর",
  SpouseName: "স্বামী/স্ত্রীর নাম",
  PermanentAddress: "স্থায়ী ঠিকানা",
  PresentAddress: "বর্তমান ঠিকানা",
  CIBUserInformation: "সিআইবি ব্যবহারকারী তথ্য",
  CIBStatus: "সিআইবি অবস্থা",
  Pleaseselectstatus: "অবস্থা নির্বাচন করুন",
  DateRange: "তারিখের পরিসীমা",
  YouCantviewthisRequest: "আপনি এই অনুরোধটি দেখতে পারবেন না।",
  FileUploadRequired: "ফাইল আপলোড প্রয়োজন।",
  DoYouwanttoacceptLoanRequest: "আপনি কি ঋণের অনুরোধটি গ্রহণ করতে চান?",
  Decline: "প্রত্যাখ্যান",

  // Loan Closure Request
  LoanClosureRequest: "ঋণ বন্ধনী অনুরোধ",
  LoanAccount: "ঋণ অ্যাকাউন্ট",
  FromAccount: "হতে অ্যাকাউন্ট",
  ClosureDate: "বন্ধনীর তারিখ",
  Amount: "পরিমাণ",
  CreditAccount: "ক্রেডিট অ্যাকাউন্ট",
  Outstanding: "অসাধারণ",
  ClosingFee: "বন্ধনী ফি",
  VAT: "ভ্যাট",
  TOTALAMOUNT: "মোট পরিমাণ",

  //Tag Account Request
  TagAccountRequest: "ট্যাগ অ্যাকাউন্ট অনুরোধ",
  RequestType: "অনুরোধের ধরণ",
  TagCreditCardRequest: "ট্যাগ ক্রেডিট কার্ড অনুরোধ",
  SearchingParameters: "অনুসন্ধানের পরামিতি",
  AppliedFilters: "প্রযোগিত ফিল্টার",

  // Loan Release Lock Request
  LoanReleaseLockRequest: "ঋণ মুক্তি লক অনুরোধ",
  FDAccount: "এফডি অ্যাকাউন্ট",
  RequestReleasedSuccessfully: "অনুরোধ সফলভাবে মুক্তি পেয়েছে।",
  AreYouSuretoReleaseLockedRequest: "আপনি কি লক অনুরোধ মুক্ত করতে নিশ্চিত?",

  // From Source Key Template
  FromSourceKeyTemplate: "সোর্স কী টেমপ্লেট",
  SettoFromSource: "সেট টু ফ্রম সোর্স",
  ResponseValue: "প্রতিক্রিয়ার মান*",
  EnterResponseValue: "প্রতিক্রিয়ার মান লিখুন",
  TemplateSetAs: "টেমপ্লেট হিসেবে সেট করুন",
  CurrentConfig: "বর্তমান কনফিগ",
  SetFromSourceKeyTemplateOf: "সেট ফ্রম সোর্স কী টেমপ্লেট অফ",

  // Account Deletion Request For Checker
  AccountDeletionRequestForChecker: "চেকারের জন্য অ্যাকাউন্ট মোছার অনুরোধ",
  PrimaryAccount: "প্রাথমিক অ্যাকাউন্ট",
  PrimaryCBNo: "প্রাথমিক সিবি নং",
  DeletionReason: "মুছে ফেলার কারণ",
  RejectRemarks: "প্রত্যাখ্যানের মন্তব্য",

  // Account Deletion Request For Approval
  AccountDeletionRequestForApproval: "অনুমোদনের জন্য অ্যাকাউন্ট মোছার অনুরোধ",
  AcceptedBy: "গ্রহণকারী",
  CheckerAcceptDate: "চেকার গ্রহণের তারিখ",
  CheckerRemarks: "চেকারের মন্তব্য",

  // Rooted Device Repository Allow/Disallow
  RootedDeviceRepositoryAllowDisallow:
    "রুটেড ডিভাইস রেপোজিটরি অনুমোদন / নিষেধাজ্ঞা",
  RootedDeviceRepository: "রুটেড ডিভাইস রেপোজিটরি",
  DeviceID: "ডিভাইস আইডি",
  DevicesOS: "ডিভাইস অপারেটিং সিস্টেম",
  DeviceName: "ডিভাইস নাম",
  DeviceUserName: "ডিভাইস ব্যবহারকারীর নাম",
  DeviceIP: "ডিভাইস আইপি",
  AppVersion: "অ্যাপ সংস্করণ",
  DeviceIMEI: "ডিভাইস আইএমইআই",
  Maker: "তৈরিকারক",
  MakerRemark: "তৈরিকারকের মন্তব্য",
  Checker: "চেকার",
  CheckerRemark: "চেকারের মন্তব্য",
  Disallow: "নিষিদ্ধ",
  Allow: "অনুমোদন",
  AllowRemarks: "অনুমোদনের মন্তব্য",
  DisallowRemarks: "নিষিদ্ধের মন্তব্য",
  RootedDeviceAllowDisallowConfirmation:
    "রুটেড ডিভাইস অনুমোদন / নিষেধাজ্ঞা নিশ্চিতকরণ",
  ConfirmationRemarks: "নিশ্চিতকরণের মন্তব্য",

  // Corporate User Registration Entry
  CorporateUserRegistrationEntry: "কর্পোরেট ব্যবহারকারী নিবন্ধন এন্ট্রি",
  DomainName: "ডোমেইন নাম",
  RegDate: "নিবন্ধনের তারিখ",
  ACNo: "এসি/নং",
  Sign: "সাইন",
  OwnAC: "নিজস্ব এসি",
  SanctionAmount: "অনুমোদিত পরিমাণ",
  WithinBank: "ব্যাংকের মধ্যে",
  EFT: "ইএফটি",
  IMPS: "আইএমপিএস",
  UtilityBillPayment: "ইউটিলিটি বিল পেমেন্ট",
  PaymentGetway: "পেমেন্ট গেটওয়ে",
  FromAmounts: "পরিমাণ থেকে",
  ToAmounts: "পর্যন্ত",
  ByNumberofUser: "ব্যবহারকারী সংখ্যা দ্বারা",
  CustomerType: "গ্রাহক প্রকার",
  PersonName: "ব্যক্তির নাম",
  Document: "ডকুমেন্ট",
  DocumentNo: "ডকুমেন্ট নং",
  UploadDocument: "ডকুমেন্ট আপলোড করুন",
  ViewDocument: "ডকুমেন্ট দেখুন",
  AuthLetter: "প্রাধিকারিক পত্র",
  ViewAuthLetter: "প্রাধিকারিক পত্র দেখুন",
  Deactive: "নিষ্ক্রিয়",
  DeactiveReason: "নিষ্ক্রিয় কারণ",
  UserRights: "ব্যবহারকারী অধিকার",
  PanNo: "প্যান নং",
  UserLimit: "ব্যবহারকারী সীমা",
  ViewOnly: "শুধুমাত্র দেখুন",
  PerDayLimit: "প্রতিদিনের সীমা",
  SpecialAuthorized: "বিশেষ অনুমোদিত",
  CorporateUserRegistration: "কর্পোরেট ব্যবহারকারী নিবন্ধন",
  PerDayMaxLimit: "প্রতিদিনের সর্বাধিক সীমা",
  Limit: "সীমা",
  ControllingPerson: "নিয়ন্ত্রণকারী ব্যক্তি",
  CorporateFinanceDepartment: "কর্পোরেট ফাইন্যান্স বিভাগ",
  AccountMapping: "একাউন্ট ম্যাপিং",
  AuthenticationWorkflow: "প্রামাণিকতা ওয়ার্কফ্লো",
  EffectiveDailyLimit: "কার্যকর দৈনিক সীমা",
  LimitAmount: "সীমা পরিমাণ",

  // Admin Panel User Maintenance
  AdminPanelUserMaintenance: "অ্যাডমিন প্যানেল ব্যবহারকারী মেইন্টেনেন্স",
  UserGroupName: "ব্যবহারকারী গ্রুপ নাম",
  GroupName: "গ্রুপ নাম",
  AllowRelease: "রিলিজ অনুমোদন",
  UserSubtype: "ব্যবহারকারীর উপ-ধরণ",
  NotificationTemplate: "বিজ্ঞপ্তি টেমপ্লেট",
  ConfirmedStatus: "নিশ্চিত স্থিতি",
  AdminPanelUserConfirmation: "অ্যাডমিন প্যানেল ব্যবহারকারী নিশ্চিতকরণ",
  UserLevel: "ব্যবহারকারী স্তর",
  EnterUserID: "ব্যবহারকারী আইডি লিখুন",
  EnterUserfullnamehere: "এখানে ব্যবহারকারীর পুরো নাম লিখুন",
  ConfirmPasswordValidation: "নতুন পাসওয়ার্ড এবং নিশ্চিত পাসওয়ার্ড মিলে না",
  ChangePasswordValidation:
    "পাসওয়ার্ড অক্ষর ও নম্বর হতে হবে এবং নিশ্চিত পাসওয়ার্ডে কমপক্ষে একটি বিশেষ চিহ্ন, একটি ছোট অক্ষর, একটি বড় অক্ষর থাকতে হবে এবং মধ্যে কোনও স্থানে কোনও স্পেস থাকতে পারবে না।",
  NewPassword: "নতুন পাসওয়ার্ড",
  ConfirmPassword: "নিশ্চিত পাসওয়ার্ড",
  InactiveDate: "নিষ্ক্রিয় তারিখ",
  UpdateDetails: "বিস্তারিত আপডেট",
  AdminUserConfirmation: "অ্যাডমিন ব্যবহারকারী নিশ্চিতকরণ",
  ConfirmationColumnDetails: "নিশ্চিতকরণ কলামের বিস্তারিত",
  OldValue: "পুরাতন মান",
  LabelName: "লেবেল নাম",
  NewValue: "নতুন মান",
  MakerDate: "তৈরিকারী তারিখ",
  MobileNoisrequired: "মোবাইল নম্বর প্রয়োজন",

  // Admin Panel User Release
  AdminPanelUserRelease: "অ্যাডমিন প্যানেল ব্যবহারকারী মুক্তি",
  LoginTime: "লগইন সময়",
  Operation: "অপারেশন",
  LoginDateTime: "লগইন তারিখ-সময়",
  BlockedReason: "অবরোধ কারণ",
  LogoutDateTime: "লগআউট তারিখ-সময়",
  ViewAll: "সব দেখুন",
  ReleaseBlockedUser: "অবরোধিত ব্যবহারকারী মুক্তি দিন",
  ReleaseUsers: "ব্যবহারকারী(সমূহ) মুক্তি দিন",
  Userissuccessfullyreleased: "ব্যবহারকারী সফলভাবে মুক্তি দেওয়া হয়েছে",
  Loggedin: "লগইন করা",
  WouldyouliketoreleasetheselectedBlockedUsers:
    "আপনি কি নির্বাচিত ব্লক করা ব্যবহারকারী(সমূহ) মুক্তি দিতে চান?",
  WouldyouliketoreleasetheselectedLoggedinUsers:
    "আপনি কি নির্বাচিত লগইন ব্যবহারকারী(সমূহ) মুক্তি দিতে চান?",
  ReleaseBlockedUsers: "ব্লক করা ব্যবহারকারী(সমূহ) মুক্তি দিন",
  AdminPanelBlockedUserRelease: "অ্যাডমিন প্যানেল ব্লক করা ব্যবহারকারী মুক্তি",
  BlockedUserName: "ব্লক করা ব্যবহারকারীর নাম",
  FailureAttemptCount: "ব্যর্থ প্রচেষ্টা গণনা",
  ListofFailedLoginAttempts: "ব্যর্থ লগইন প্রচেষ্টা তালিকা",
  UserFailedAttemptDetails: "ব্যবহারকারীর ব্যর্থ প্রচেষ্টা বিশদ",
  ReleaseReason: "মুক্তি দেওয়ার কারণ",
  ApplicationSessionID: "অ্যাপ্লিকেশন সেশন আইডি",

  // Screen Access Rights
  ScreenAccessRights: "স্ক্রিন অ্যাক্সেস অধিকার",
  GroupNames: "গ্রুপ নাম",
  AccessDetail: "অ্যাক্সেস বিবরণ",
  Groups: "গোষ্ঠী",
  Users: "ব্যবহারকারীগণ",
  Youcannotmodifyyourownrights: "আপনি নিজের অধিকার পরিবর্তন করতে পারবেন না।",
  AreyouwanttopopulateitsGroupRight: "আপনি কি এর গ্রুপ অধিকার পূরণ করতে চান?",
  MenuList: "মেনু তালিকা",
  PendingScreenAccess: "মুলতুবি স্ক্রিন অ্যাক্সেস",
  CurrentScreenAccess: "বর্তমান স্ক্রিন অ্যাক্সেস",
  AssignUserGroupRights: "ব্যবহারকারী/গ্রুপ অধিকার নির্ধারণ করুন",
  CarryForwardScreenRightsFrom: "স্ক্রিন অধিকার এগিয়ে নিন",
  YoucannotCarryForwardRightsforsameuser:
    "আপনি একই ব্যবহারকারীর জন্য অধিকার এগিয়ে নিতে পারবেন না।",
  AssignUserGroupRightsTo: "ব্যবহারকারী/গ্রুপ অধিকার নির্ধারণ করুন ",
  FastForward: "দ্রুত অগ্রগামী",
  FastRewind: "দ্রুত পুনরায়",
  ScreenAccessRightsOf: "স্ক্রিন অ্যাক্সেস অধিকার অফ {0} ব্যবহারকারী",
  User: " ব্যবহারকারী",

  // Admin Panel User Group
  AdminPanelUserGroupCreation: "অ্যাডমিন প্যানেল ব্যবহারকারী গ্রুপ তৈরি",
  NoofScreenstodisplayunderRecentOption:
    "সাম্প্রতিক অপশনে প্রদর্শন করার জন্য স্ক্রিন সংখ্যা",
  LoginPasswordForceExpiryDays: "লগইন পাসওয়ার্ড বাধা মেয়াদ উত্তীর্ণের দিন",
  EnterLoginPasswordForceExpiryDays:
    "লগইন পাসওয়ার্ড বাধা মেয়াদ উত্তীর্ণের দিন লিখুন",
  AdminUserGroupMaintenance: "অ্যাডমিন ব্যবহারকারী গ্রুপ রক্ষণাবেক্ষণ",
  EnterUserGroupName: "ব্যবহারকারী গ্রুপ নাম লিখুন",
  NoofScreensunderRecentOption: "সাম্প্রতিক অপশনে স্ক্রিনের সংখ্যা",
  EnterNoofScreensunderRecentOption: "সাম্প্রতিক অপশনে স্ক্রিনের সংখ্যা লিখুন",
  UserGroup: "ব্যবহারকারী গ্রুপ",

  // Admin User Notification Template
  AdminUserNotificationTemplate: "অ্যাডমিন ব্যবহারকারী বিজ্ঞপ্তি টেমপ্লেট",
  NotificationTemplateName: "বিজ্ঞপ্তি টেমপ্লেটের নাম",
  AdminUserNotificationTemplateName:
    "অ্যাডমিন ব্যবহারকারী বিজ্ঞপ্তি টেমপ্লেট নাম",
  EnterAdminUserNotificationTemplateName:
    "অ্যাডমিন ব্যবহারকারী বিজ্ঞপ্তি টেমপ্লেট নাম লিখুন",
  UserLoginIDReq: "ব্যবহারকারী লগইন আইডি*",
  USERLoginIDisAlreadyenteredatLine:
    "ব্যবহারকারী লগইন আইডি লাইনে ইতিমধ্যে লিখা আছে",

  // Release Block Users
  ReleaseBlockUsers: "রিলিজ ব্লক ব্যবহারকারীগণ",
  ReleaseTypeReq: "রিলিজ প্রকার*",
  BlockTypeReq: "ব্লক প্রকার*",
  BlockDate: "ব্লক তারিখ",
  BlockReason: "ব্লক কারণ",
  ReleaseCardPINBlockUsers: "কার্ড পিন ব্লক ব্যবহারকারীগণ মুক্তি দিন",
  ActivityType: "কার্যকলাপের প্রকার",
  Details: "বিস্তারিত",
  Areyousureyouwanttorelease: "আপনি কি নিশ্চিত যে আপনি মুক্তি দিতে চান",
  ReleasePGWBlockUsers: "পিজিডব্লিউ ব্লক ব্যবহারকারীগণ মুক্তি দিন",
  Fetch: "তথ্য নিন",

  // DBR Loan Request Check
  DBRLoanRequestCheck: "ডিবিআর ঋণ অনুরোধ পরীক্ষা",
  CustomerLoanRequestInformation: "গ্রাহক ঋণের অনুরোধের তথ্য",
  Profession: "পেশা",
  NetMonthlyIncomeA: "মাসিক মোট আয় (এ)",
  TDAccountNumber: "টি ডি হিসাব নম্বর",
  TenorMonth: "অবধি (মাস)",
  TDAmountC: "টি ডি পরিমাণ (সি)",
  RateofInterest: "সুদের হার",
  EMIB: "ইএমআই (বি)",
  AccountforEncashEMI: "ইএমআই এনক্যাশের জন্য হিসাব",
  DBRBA: "ডিবিআর (বি/এ)%",
  LoanRequestRecommendedInformation: "ঋণের অনুরোধ প্রস্তাবিত তথ্য",
  LoanAmountD: "ঋণের পরিমাণ (ডি)",
  OtherLoanInstF: "অন্যান্য ঋণ ইনস্ট। (এফ)",
  CreditCardlimitG: "ক্রেডিট কার্ড সীমা (জি)",
  DBRF5ofGA100: "ডিবিআর% ((এফ + জি এর 5%)/এ)*100",
  EMIE: "ইএমআই (ই)",
  LTVDC: "এলটিভি% (ডি/সি)",
  FinalLoanAmountLTVC: "চূড়ান্ত ঋণের পরিমাণ (এলটিভি * সি)",
  CIBRemarks: "সিআইবি মন্তব্য",
  MessagefromDBR: "ডিবিআর থেকে বার্তা",
  DBRRemarks: "ডিবিআর মন্তব্য",
  Requesthasalreadybeenprocessed: "অনুরোধ ইতিমধ্যে প্রক্রিয়াজাত হয়েছে।",
  ViewDocuments: "নথি দেখুন",

  // Loan Approval Detail
  LoanApprovalDetail: "ঋণ অনুমোদনের বিস্তারিত",
  LoanApprovalRequestDetails: "ঋণ অনুমোদনের অনুরোধের বিস্তারিত",
  FileReferenceNo: "ফাইল রেফারেন্স নম্বর",
  SecurityValueTDAmount: "নিরাপত্তা মান/টি ডি পরিমাণ",
  AssessedbyDBRID: "মূল্যায়ন করেছে/ডিবিআর আইডি",
  AssessedbyDBRName: "মূল্যায়ন করেছে/ডিবিআর নাম",
  AssessedDate: "মূল্যায়নের তারিখ",
  LTV: "এলটিভি%",
  NetMonthlyIncome: "নেট মাসিক আয়",
  Tenor: "অবধি",
  OtherLoanInstallment: "অন্যান্য ঋণ কিস্তি",
  CreditCardlimit: "ক্রেডিট কার্ডের সীমা",
  EMI: "ইএমআই",
  DBR: "ডিবিআর",
  SOLID: "এসওএল আইডি",
  FinalLoanAmount: "চূড়ান্ত ঋণের পরিমাণ",
  MessageFromApproval: "অনুমোদন থেকে বার্তা",

  // Enter Retrieval Parameters
  EnterRetrievalParameters: "পুনরুদ্ধার পরিমাপকগুলি লিখুন",
  ToDateshouldbegreaterthanorequaltoFromDate:
    "শেষ তারিখ শুরু তারিখ থেকে বড় অথবা সমান হতে হবে।",
  FromDateshouldbelessthanorequaltoToDate:
    "শুরু তারিখ শেষ তারিখ থেকে ছোট অথবা সমান হতে হবে।",
  today: "আজ",
  accept: "গ্রহণ করুন",
  cancel: "বাতিল করুন",

  //REPORT
  RetrievalParameters: "পুনঃপাঠ্যাকার পরিমাণ",
  Searched: "অনুসন্ধান করা হয়েছে",
  records: "রেকর্ড",
  showFilters: "ফিল্টার দেখান",
  ClearFilter: "ফিল্টার মুছুন",
  ExpandRows: "সারিগুলি প্রসারিত করুন",
  Export: "রপ্তানি",
  Showexportoptions: "রপ্তানি বিকল্প দেখান",
  RetrieveData: "ডেটা পুনরুদ্ধার করুন",
  RequiredValueMissingForLoginID: "লগইন আইডির জন্য প্রয়োজনীয় মান অনুপস্থিত",
  rowswillbeexported: "সারি(গুলি) রপ্তানি করা হবে।",
  Nodatafoundtoexport: "রপ্তানির জন্য কোন তথ্য পাওয়া যায় নি",
  ReportExportStatus: "রিপোর্ট রপ্তানির অবস্থা",

  // Customer Registration Report
  CustomerRegistrationReport: "গ্রাহক নিবন্ধন রিপোর্ট",
  RegAccountCardNumber: "নিবন্ধিত অ্যাকাউন্ট/কার্ড নম্বর",
  Source: "উৎস",
  AuthWith: "অনুমোদন করুন সঙ্গে",
  LastPassChange: "সর্বশেষ পাসওয়ার্ড পরিবর্তন",

  // User Login History
  UserLoginHistory: "ব্যবহারকারীর লগইন ইতিহাস",
  LoginDate: "লগইন তারিখ",
  LoginBy: "লগইন করা হয়েছে",

  // Password Change History
  PasswordChangeHistory: "পাসওয়ার্ড পরিবর্তন ইতিহাস",
  PasswordModifyDate: "পাসওয়ার্ড পরিবর্তনের তারিখ",

  // User Activity
  UserActivity: "ব্যবহারকারী ক্রিয়াকলাপ",
  ActivityCode: "ক্রিয়াকলাপ কোড",
  ActivityTime: "ক্রিয়াকলাপ সময়",
  ActivityDescription: "ক্রিয়াকলাপের বর্ণনা",

  // Fund Transfer Transaction Details
  FundTransferTransactionDetails: "তহবিল স্থানান্তর লেনদেনের বিশদ",
  TransactionStatus: "লেনদেনের অবস্থা",
  TransactionDate: "লেনদেনের তারিখ",
  VATAmount: "ভ্যাট পরিমাণ",
  FromSource: "থেকে উৎস",
  FromACNo: "হইতে এসি/নং",
  FromACName: "হইতে এসি/নাম",
  ToACNo: "প্রতি এসি/নং",
  ToACName: "প্রতি এসি/নাম",
  ToIFSCCode: "প্রতি আইএফএসসি কোড",
  ProcessDate: "প্রক্রিয়া তারিখ",
  RefNo: "রেফারেন্স নং.",
  OTPType: "ওটিপি ধরন",
  FromContactNo: "থেকে যোগাযোগ নং.",
  FromEmailID: "থেকে ইমেল আইডি",
  ToContactNo: "প্রতি যোগাযোগ নং.",
  ToEmailID: "প্রতি ইমেল আইডি",
  TransFlow: "লেনদেন প্রবাহ",
  NickName: "প্রদর্শিত নাম",

  APIResponseDetailsReport: "API প্রতিক্রিয়া বিবরণ রিপোর্ট",
  ApiName: "API নাম",
  RespCode: "প্রতিক্রিয়া কোড",
  RefTranID: "রেফ.ট্রান্স.আইডি",
  ResponseMessage: "প্রতিক্রিয়া বার্তা",
  ResponseDate: "প্রতিক্রিয়া তারিখ",
  ExportReportform: "রিপোর্ট ফর্ম রপ্তানি করুন",

  Selectfiletype: "ফাইল প্রকার নির্বাচন করুন",
  Selectpagesize: "পৃষ্ঠা আকার নির্বাচন করুন",
  Selectorientation: "অবস্থান নির্বাচন করুন",
  ShowHeader: "শিরোনাম দেখান",
  ColumnstoExport: "রপ্তানির জন্য কলামগুলি",
  TransactionParticularsDetail: "লেনদেনের বিশদ বিবরণ",
  Print: "মুদ্রণ",
  ResponseDetail: "প্রতিক্রিয়া বিবরণ",

  TransactionRefNumber: "লেনদেন রেফারেন্স নম্বর",
  FromAccountNumber: "হইতে অ্যাকাউন্ট নম্বর",
  AbabilTrnParticulars: "আবাবিল লেনদেন বিশদ",
  AbabilTrnParticulars2: "আবাবিল লেনদেন বিশদ ২",
  TranzwareTrnParticulars: "ট্রানজওয়্যার লেনদেন বিশদ",
  TranzwareTrnParticulars2: "ট্রানজওয়্যার লেনদেন বিশদ ২",

  // Service Active/Deactive Register
  ServiceActiveDeactiveRegister: "সেবা সক্রিয়/নিষ্ক্রিয় রেজিস্টার",
  SubTranType: "সাব লেনদেনের প্রকার",
  FromDates: "হইতে তারিখ",
  ToDates: "পর্যন্ত তারিখ",
  DisplayMessage: "প্রদর্শন বার্তা",
  DisplayMessageDetail: "প্রদর্শন বার্তা বিশদ",

  // Mobile/Email Updation From Core Report
  MobileEmailUpdationFromCoreReport: "মোবাইল/ইমেল কোর রিপোর্ট থেকে আপডেশন",
  UpdatedField: "আপডেট ক্ষেত্র",

  // OTP Notification Report
  OTPNotificationReport: "ওটিপি বিজ্ঞপ্তি রিপোর্ট",
  TRNCode: "টি.আর.এন কোড",
  MobileNoEmailID: "মোবাইল নম্বর/ইমেল আইডি",
  SentTime: "পাঠানোর সময়",
  MessageDescription: "বার্তা বর্ণনা",
  ApiResp: "এপিআই প্রতিক্রিয়া",
  PageNumber: "পৃষ্ঠা নম্বর",
  EnterPageNumber: "পৃষ্ঠা নম্বর লিখুন",
  PageSize: "পৃষ্ঠা আকার",
  EnterPageSize: "পৃষ্ঠার আকার লিখুন",

  // List Of Club Member Report
  ListOfClubMemberReport: "ক্লাব সদস্যের তালিকা রিপোর্ট",
  Pleaseselectatleastonerow: "অনুগ্রহ করে অন্তত একটি সারি নির্বাচন করুন।",

  // Mobile/Email Notification Report
  MobileEmailNotificationReport: "মোবাইল/ইমেল বিজ্ঞপ্তি রিপোর্ট",
  MessageType: "বার্তা প্রকার",

  // Beneficiary Detail Report
  BeneficiaryDetailReport: "সুবিধাভোগী বিশদ রিপোর্ট",
  BeneficiaryType: "সুবিধাভোগী প্রকার",

  // Mobile/Email Updation From Citytouch Report
  MobileEmailUpdationFromCitytouchReport:
    "সিটিটাচ রিপোর্ট থেকে মোবাইল/ইমেল আপডেশন",
  ReqestDate: "অনুরোধের তারিখ",
  ResponseCode: "প্রতিক্রিয়া কোড",

  // Email Transfer Transaction Details
  EmailTransferTransactionDetails: "ইমেল স্থানান্তর লেনদেনের বিবরণ",
  AcceptStatus: "গ্রহণ অবস্থা",
  ResentCount: "পুনঃপ্রেরিত গণনা",
  CancelReason: "বাতিল কারণ",

  // Cash By Code Transaction Details
  CashByCodeTransactionDetails: "কোড দ্বারা নগদ লেনদেনের বিবরণ",
  FromCardNumber: "কার্ড নম্বর থেকে",
  LinkedACNo: "সংযুক্ত এসি/নং",
  CodeViewBy: "কোড দ্বারা দেখুন",
  CashByCode: "কোড দ্বারা নগদ",
  BenConatctNo: "সুবিধাভোগী যোগাযোগ নম্বর",

  // Favourite Transaction Details
  FavouriteTransactionDetails: "প্রিয় লেনদেনের বিবরণ",
  FavType: "প্রিয় প্রকার",
  FavTranname: "প্রিয় লেনদেনের নাম",

  // Payment Details
  PaymentDetails: "পেমেন্টের বিবরণ",
  PaymentDate: "পেমেন্টের তারিখ",
  ToSource: "প্রাপ্তিস্থান",
  ServiceCharge: "সেবা চার্জ",
  Mobile: "মোবাইল",
  ResponseDesc: "প্রতিক্রিয়া বর্ণনা",
  RefTransactionID: "রেফ.লেনদেন আইডি",
  MerchantName: "ব্যবসায়ীর নাম",
  Frequency: "প্রয়োগক্ষমতা",
  AsonDate: "তারিখ অনুযায়ী",
  DeselectAll: "সব অগ্রাহ্য করুন",
  SelectAll: "সব নির্বাচন করুন",

  // Schedule Payment Details
  SchedulePaymentDetails: "সময়সূচী পেমেন্ট বিবরণ",
  LastProcessDate: "শেষ প্রসেসের তারিখ",
  DeactiveChannel: "অসক্রিয় চ্যানেল",
  PaymentType: "পেমেন্টের প্রকার",
  NoofPayments: "পেমেন্টের সংখ্যা",
  PolicyNumber: "পলিসি নম্বর",
  PolicyHolderName: "পলিসি ধারকের নাম",
  PolicyPaidType: "পলিসি পেইড টাইপ",
  ScheduleResponse: "সময়সূচী প্রতিক্রিয়া",

  ScheduleDetailsReport: "সময়সূচী বিবরণ রিপোর্ট",
  ScheduleDate: "সময়সূচীর তারিখ",
  FromAccountNo: "থেকে অ্যাকাউন্ট নম্বর",
  FromAccountName: "থেকে অ্যাকাউন্ট নাম",
  ToAccountNo: "প্রতি অ্যাকাউন্ট নম্বর",
  ToAccountName: "প্রতি অ্যাকাউন্ট নাম",
  BenContactNo: "সুবিধাভোগী যোগাযোগ নম্বর",
  BenEmailID: "সুবিধাভোগী ইমেল আইডি",
  RefDate: "রেফ. তারিখ",

  // Card Activate/Reset Pin Report
  CardActivateResetPinReport: "কার্ড চালু/রিসেট পিন রিপোর্ট",
  TypeOfTran: "লেনদেনের ধরন",
  CardNo: "কার্ড নম্বর",
  OldStatusOfCard: "কার্ডের পুরাতন অবস্থা",
  NewStatusOfCard: "কার্ডের নতুন অবস্থা",
  ChangeReason: "পরিবর্তনের কারণ",
  ResponseMesssage: "প্রতিক্রিয়া বার্তা",

  // Tag Credit Card And Account Number Details
  TagCreditCardAndAccountNumberDetails:
    "ক্রেডিট কার্ড এবং অ্যাকাউন্ট নম্বরের তাগ বিবরণ",
  AcOrCardNo: "অ্যাকাউন্ট বা কার্ড নম্বর",
  AcceptBy: "গ্রহণকারী",
  AcceptDate: "গ্রহণের তারিখ",
  AcceptanceRemarks: "গ্রহণের মন্তব্য",

  // Untag Credit Card And Account Number Details
  UntagCreditCardAndAccountNumberDetails:
    "ক্রেডিট কার্ড এবং অ্যাকাউন্ট নম্বরের বিবরণ অনট্যাগ করুন",

  // Positive Pay Request Report
  PositivePayRequestReport: "পজিটিভ পে অনুরোধ রিপোর্ট",
  BeneficiaryName: "প্রায়োজকের নাম",
  ChequeDate: "চেকের তারিখ",
  ChequeNumber: "চেক নম্বর",
  ChequeBookNumber: "চেক বই নম্বর",

  // QR Generated Report
  QRGeneratedReport: "কিউআর তৈরি রিপোর্ট",
  QRID: "কিউআর আইডি",
  Currency: "মুদ্রা",
  ProcessStatus: "প্রসেস স্থিতি",

  // QR Merchant Payment Report
  QRMerchantPaymentReport: "কিউআর মার্চেন্ট পেমেন্ট রিপোর্ট",

  // Cheque Book Request Report
  ChequeBookRequestReport: "চেক বই অনুরোধ রিপোর্ট",
  NoOfLeaf: "পাতা সংখ্যা",
  DeliveryBranch: "বিতরণ শাখা",

  // Cheque Stop Request Report
  ChequeStopRequestReport: "চেক বন্ধ অনুরোধ রিপোর্ট",
  BeginChequeNo: "চেক শুরু করুন নং",
  ChequeNo: "চেক নম্বর",
  ContactNo: "যোগাযোগ নম্বর",
  EnterContactNo: "প্রবেশ করা যোগাযোগ নম্বর",

  // User Block Unblock Report
  UserBlockUnblockReport: "ব্যবহারকারী ব্লক আনব্লক রিপোর্ট",
  BlockType: "ব্লকের প্রকার",

  // Apply for Fixed Deposite Request Report
  ApplyforFixedDepositeRequestReport: "ফিক্সড ডিপোজিটের জন্য আবেদন রিপোর্ট",
  TypeOfAccount: "অ্যাকাউন্টের প্রকার",
  AccountTitle: "অ্যাকাউন্ট টাইটেল",
  AvilBalance: "উপলব্ধ ব্যালেন্স",
  TenureType: "কালার ধরন",
  AutoRenewal: "স্বয়ংক্রিয় নবায়ন",
  IntRepayAccount: "ইন্ট./পরিশোধ অ্যাকাউন্ট",
  CollectionBranch: "সংগ্রহ শাখা",
  InterestRate: "সুদের হার",
  MaturityDate: "পরিপূর্ণ তারিখ",
  ApplyForDepositPensionSchemeReport:
    "ডিপোজিট পেনশন স্কিমের জন্য আবেদন রিপোর্ট",
  InstallStartDate: "ইনস্টল শুরুর তারিখ",
  GeneratedAccount: "জেনারেটেড অ্যাকাউন্ট",

  // Credit Card Payment Report
  CreditCardPaymentReport: "ক্রেডিট কার্ড পেমেন্ট রিপোর্ট",
  ReferenceNo: "রেফারেন্স নম্বর",
  FromACNumber: "অ্যাকাউন্ট নম্বর থেকে",
  ToCardNo: "কার্ড নম্বরে",
  Recipientname: "প্রাপকের নাম",
  RecipientEmail: "প্রাপকের ইমেল",
  CurrCode: "মুদ্রা কোড",
  ToCurrCode: "মুদ্রা কোড পর্যন্ত",
  CurrInt: "মুদ্রা সুদ",
  CardType: "কার্ড প্রকার",
  TotalAmount: "সর্বমোট পরিমাণ",

  // Admin Panel User Application Usage History
  AdminPanelUserApplicationUsageHistory:
    "অ্যাডমিন প্যানেল ব্যবহারকারী অ্যাপ্লিকেশন ব্যবহারের ইতিহাস",
  OpenDateAndTime: "খোলা তারিখ এবং সময়",
  CloseDateAndTime: "বন্ধ তারিখ এবং সময়",

  // Apply for Quick Loan Summary Report
  ApplyforQuickLoanSummaryReport:
    "দ্রুত ঋণের সারসংক্ষেপ রিপোর্টের জন্য আবেদন করুন",
  RequestDateandTime: "অনুরোধের তারিখ এবং সময়",
  EMIAccount: "EMI অ্যাকাউন্ট",
  IntRate: "সুদের হার",
  ApplyforQuickLoanDetailReport:
    "দ্রুত ঋণের বিস্তারিত রিপোর্টের জন্য আবেদন করুন",
  LoanTenure: "ঋণের মেয়াদ",
  MonthlyIncome: "মাসিক আয়",
  ProcessingFee: "প্রসেসিং ফি",
  FileREFNo: "ফাইল REF নম্বর",
  ETINNo: "ই টিআইএন নম্বর",
  NIDNo: "এনআইডি নম্বর",
  SmartCardNo: "স্মার্ট কার্ড নম্বর",
  BirthPlace: "জন্মস্থান",
  SoalID: "সোয়াল আইডি",
  SanIntRate: "স্যান. সুদের হার",
  OtherLoanEMI: "অন্যান্য ঋণ EMI",
  SanLoanAmount: "স্যান ঋণের পরিমাণ",
  EMIDate: "EMI তারিখ",
  CCLimitAmount: "সিসি লিমিট পরিমাণ",
  SanInstAmount: "স্যান ইনস্ট. পরিমাণ",
  DBRAmount: "DBR পরিমাণ",
  CIBUser: "CIB ব্যবহারকারী",
  CIBEnteredDate: "CIB প্রবেশের তারিখ",
  CIBMachineName: "CIB মেশিনের নাম",
  DBRUsers: "DBR ব্যবহারকারী",
  DBREnteredDate: "DBR প্রবেশের তারিখ",
  DBRMachineName: "DBR মেশিনের নাম",
  AuthUser: "প্রাধিকৃত ব্যবহারকারী",
  AuthRemarks: "প্রাধিকৃত মন্তব্য",
  AuthEnteredDate: "প্রাধিকৃত প্রবেশের তারিখ",
  AuthMachineName: "প্রাধিকৃত মেশিনের নাম",
  RejectedBy: "বাতিল করেছে",
  RejectedDate: "বাতিল তারিখ",
  RejectedMachineName: "বাতিল মেশিনের নাম",
  FDBalance: "এফডি ব্যালেন্স",

  // Merchant Transaction Report
  MerchantTransactionReport: "মার্চেন্ট লেনদেন রিপোর্ট",
  RequestDateTime: "অনুরোধের তারিখ এবং সময়",
  UniqueID: "অদ্বিতীয় আইডি",
  BankRefID: "ব্যাংক রেফারেন্স আইডি",
  MerchantReferenceID: "মার্চেন্ট রেফারেন্স আইডি",
  TokenNo: "টোকেন নম্বর",
  ServiceType: "সেবা প্রকার",
  ReverseStatus: "রিভার্স স্থিতি",

  // Supporting Documents Upload Report
  SupportingDocumentsUploadReport: "সহায়ক নথি আপলোড রিপোর্ট",
  RegistrationDate: "নিবন্ধনের তারিখ",
  ChangeRequestType: "পরিবর্তনের অনুরোধের ধরণ",
  APIResponceID: "এপিআই প্রতিক্রিয়া আইডি",
  DocumentName: "নথির নাম",
  DocumentFileName: "নথি ফাইল নাম",

  // Pay Order Details Report
  PayOrderDetailsReport: "পে অর্ডার বিস্তারিত রিপোর্ট",
  TransactionTime: "লেনদেনের সময়",
  TypeOfFundTransfer: "তহবিল স্থানান্তরের ধরণ",
  DeliveryBranchName: "ডেলিভারি শাখার নাম",
  TransferRefNumber: "স্থানান্তর রেফারেন্স নম্বর",

  // FDR Issuance Report
  FDRIssuanceReport: "এফডিআর ইস্যুয়েন্স রিপোর্ট",
  RequestCompletedDateTime: "অনুরোধ সম্পন্ন তারিখ সময়",
  SOLDescription: "এসওএল বর্ণনা",
  CIFID: "সিআইএফ আইডি",
  FDRType: "এফডিআর প্রকার",
  AcName: "অ্যাকাউন্টের নাম",
  AcOpeningDate: "অ্যাকাউন্ট খোলার তারিখ",
  IntCreditAcID: "মুনাফা শ্রেয় অ্যাকাউন্ট আইডি",
  IntCreditAcName: "মুনাফা শ্রেয় অ্যাকাউন্টের নাম",
  ValueDate: "মানের তারিখ",
  DepositAmount: "জমা পরিমাণ",
  DepositPeriod: "জমার সময়কাল",
  TenorType: "টেনর প্রকার",
  MaturityValue: "পরিপন্নতা মান",
  RepaymentAcID: "পরিশোধ অ্যাকাউন্ট আইডি",
  RepaymentAcName: "পরিশোধ অ্যাকাউন্টের নাম",
  MaturityInstructions: "পরিপন্নতা নির্দেশিকা",
  AutoClosure: "অটো সংযোগ",
  SectorCode: "সেক্টর কোড",
  SubSectorCode: "উপ-সেক্টর কোড",
  OccupationCode: "পেশা কোড",
  FreeCode3: "ফ্রি কোড 3",
  FreeCode6: "ফ্রি কোড 6",
  FreeCode7: "ফ্রি কোড 7",
  DebitAcID: "ডেবিট অ্যাকাউন্ট আইডি",
  DebitAcName: "ডেবিট অ্যাকাউন্টের নাম",
  NomineesName: "নোমিনির নাম",
  Relationship: "সম্পর্ক",
  AddressLine1: "ঠিকানা লাইন 1",
  AddressLine2: "ঠিকানা লাইন 2",
  NomineePhotoID: "নোমিনির ফটো আইডি",
  City: "শহর",
  State: "রাষ্ট্র",
  Country: "দেশ",
  NomineeMinor: "নোমিনি মাইনর",
  DateOfBirth: "জন্ম তারিখ",
  NomineePent: "নোমিনি পেন্ট.",
  RequestID: "রিকোয়েস্ট আইডি",

  // DPS Issuance Report
  DPSIssuanceReport: "ডিপিএস ইস্যুয়েন্স রিপোর্ট",
  SISrlNo: "এসআই সিরিয়াল নম্বর",
  StandInstFreqType: "স্ট্যান্ডার্ড ইনস্ট্যান্ট ফ্রিকুয়েন্স টাইপ",
  DayofStandInstFreq: "দিন অফ স্ট্যান্ডার্ড ইনস্ট্যান্ট ফ্রিকুয়েন্স",
  StandInstFreq: "স্ট্যান্ডার্ড ইনস্ট্যান্ট ফ্রিকুয়েন্স",
  NextExecutionDate: "পরবর্তী কার্যকরি তারিখ",

  // API Response Report
  APIResponseReport: "এপিআই প্রতিক্রিয়া রিপোর্ট",
  APICallCount: "এপিআই কল গণনা",

  // Admin Panel User Information Report
  AdminPanelUserInformationReport: "অ্যাডমিন প্যানেল ব্যবহারকারী তথ্য রিপোর্ট",
  CreationDate: "সৃষ্টির তারিখ",

  // Admin Panel User Activity Report
  AdminPanelUserActivityReport: "অ্যাডমিন প্যানেল ব্যবহারকারী ক্রিয়া রিপোর্ট",
  LogDescription: "লগ বর্ণনা",
  LoginIpAddress: "লগইন আইপি ঠিকানা",
  Terminal: "টার্মিনাল",
  ReleasedBy: "মুক্তিদানকারী",
  ReleasedDate: "মুক্তি প্রদানের তারিখ",
  ReleasedIpAddress: "মুক্তিদানের আইপি ঠিকানা",

  // Perameters Audit Trail
  PerametersAuditTrail: "প্যারামিটার অডিট ট্রেল",
  PeraNo: "প্যারা নম্বর",
  ModifiedDateTime: "সংশোধিত তারিখ - সময়",

  // Admin Panel User Audit Trail Detail
  AdminPanelUserAuditTrailDetail:
    "অ্যাডমিন প্যানেল ব্যবহারকারী অডিট ট্রেল বিস্তারিত",
  ActionDateTime: "কর্ম তারিখ এবং সময়",
  AdminPanelUserWiseScreenAccessReport:
    "অ্যাডমিন প্যানেল ব্যবহারকারী অনুযায়ী স্ক্রিন অ্যাক্সেস রিপোর্ট",
  ScreenCode: "স্ক্রিন কোড",

  // Monthly Service And Channel Wise MAU Report
  MonthlyServiceAndChannelWiseMAUReport:
    "মাসিক সেবা এবং চ্যানেল জ্ঞানক্ষেত্রে MAU রিপোর্ট",
  Month: "মাস",
  Transaction: "লেনদেন",
  Volume: "আয়তন",
  UniqueCustomer: "অনন্য গ্রাহক",
  DailyServiceAndChannelWiseMAUReport:
    "দৈনিক সেবা এবং চ্যানেল জ্ঞানক্ষেত্রে MAU রিপোর্ট",
  PleaseSelectAtLeastOneChannel: "অন্তত একটি চ্যানেল নির্বাচন করুন৷",
  PleaseSelectAtLeastOneTrnType:
    "অনুগ্রহ করে অন্তত একটি লেনদেনের প্রকার নির্বাচন করুন৷",

  // Monthly User And Channel Wise MAU Report
  MonthlyUserAndChannelWiseMAUReport:
    "মাসিক ব্যবহারকারী এবং চ্যানেল জ্ঞানক্ষেত্রে MAU রিপোর্ট",
  NumberOfService: "সেবার সংখ্যা",
  DailyUserAndChannelWiseMAUReport:
    "দৈনিক ব্যবহারকারী এবং চ্যানেল জ্ঞানক্ষেত্রে MAU রিপোর্ট",

  // Primary Identifier Change Report
  PrimaryIdentifierChangeReport: "প্রাথমিক সনাক্তকারী পরিবর্তন রিপোর্ট",
  OldSource: "পুরাতন উৎস",
  NewSource: "নতুন উৎস",
  OldCardaccountNo: "পুরাতন কার্ড/অ্যাকাউন্ট নম্বর",
  NewCardaccountNo: "নতুন কার্ড/অ্যাকাউন্ট নম্বর",
  ChangedBy: "পরিবর্তন করেছেন",
  ChangedDate: "পরিবর্তিত তারিখ",

  // Device Change Report
  DeviceChangeReport: "ডিভাইস পরিবর্তন রিপোর্ট",

  // Currently Login Customer Details Report
  CurrentlyLoginCustomerDetailsReport:
    "বর্তমানে লগইন গ্রাহকের বিস্তারিত রিপোর্ট",
  LastLoginDateTime: "সর্বশেষ লগইনের তারিখ এবং সময়",
  LastActivityDateTime: "সর্বশেষ কার্যক্রমের তারিখ এবং সময়",
  InactiveTime: "নিষ্ক্রিয় সময়",
  TTL: "টিটিএল",
  LastActivityType: "সর্বশেষ কার্যক্রমের ধরণ",
  LastActivityDescription: "সর্বশেষ কার্যক্রমের বিবরণ",

  // Mobile Recharge Details Report
  MobileRechargeDetailsReport: "মোবাইল রিচার্জ বিস্তারিত রিপোর্ট",
  ConnectionType: "সংযোগের ধরণ",
  OTPMobileNumber: "ওটিপি মোবাইল নম্বর",
  OTPEmailID: "ওটিপি ইমেল আইডি",

  // Account Deletion Request Report
  AccountDeletionRequestReport: "অ্যাকাউন্ট মুছে ফেলার অনুরোধ রিপোর্ট",
  PrimaryCBCID: "প্রাথমিক সিবি/সিআইডি",
  CheckerDate: "চেকারের তারিখ",

  // Topup Reversal Report
  TopupReversalReport: "টপআপ রিভার্সাল রিপোর্ট",
  TopupTranCode: "টপআপ লেনদেন কোড",
  MerechantRefID: "বাণিজ্যিক রেফারেন্স আইডি",
  AmountStatus: "পরিমাণের অবস্থা",
  RequestIP: "অনুরোধের আইপি",
  Rechargedate: "টপআপ তারিখ",

  // Merchant Transaction Reversal Report
  MerchantTransactionReversalReport: "বণিক লেনদেন রিভার্সাল রিপোর্ট",
  ReversedBy: "রিভার্স করেছেন",
  ReversedDateTime: "রিভার্সের তারিখ ও সময়",
  AcceptedDateTime: "গ্রহণের তারিখ ও সময়",
  ReversedMachineName: "রিভার্সের মেশিনের নাম",
  AcceptedMachineName: "গ্রহণের মেশিনের নাম",

  // User Status Change Audit Report
  UserStatusChangeAuditReport: "ব্যবহারকারী স্থিতি পরিবর্তন অডিট রিপোর্ট",
  NewStatus: "নতুন স্থিতি",

  //Utility Bill Payment Report
  UtilityBillPaymentReport: "প্রযুক্তিসহায়ক বিল পেমেন্ট রিপোর্ট",
  Category: "বিভাগ",
  TrnStatus: "লেনদেনের অবস্থা",
  Retrieve: "পুনরুদ্ধার",
  BillNumber: "বিল নম্বর",
  GrandTotal: "সর্বমোট",
  OTPMobileNo: "ওটিপি মোবাইল নম্বর",
  TransactionRefID: "লেনদেন রেফারেন্স আইডি",
  OtherDetails: "অন্যান্য বিবরণ",

  // Daily Service And Channel Wise Charges report
  DailyServiceAndChannelWiseChargesreport:
    "দৈনিক সেবা এবং চ্যানেল অনুযায়ী খরচ রিপোর্ট",
  MonthlyServiceAndChannelWiseChargesReport:
    "মাসিক সেবা এবং চ্যানেল অনুযায়ী খরচ রিপোর্ট",

  // Insurance Premium Payment Report
  InsurancePremiumPaymentReport: "ইন্স্যুরেন্স প্রিমিয়াম পেমেন্ট রিপোর্ট",
  CompanyName: "কোম্পানির নাম",
  TransferType: "স্থানান্তর প্রকার",
  ToAccount: "অ্যাকাউন্টে যেতে",

  // MFS Transfer Transation Details
  MFSTransferTransationDetails: "এমএফএস স্থানান্তর লেনদেনের বিবরণ",
  TransationDate: "লেনদেনের তারিখ",
  TransationType: "লেনদেনের প্রকার",

  // Customer Wise Global Limit Usage Report
  CustomerWiseGlobalLimitUsageReport:
    "গ্রাহক মুলতুবলে গ্লোবাল লিমিট ব্যবহারের রিপোর্ট",
  GlobalLimit: "গ্লোবাল লিমিট",
  TransactionCount: "লেনদেনের সংখ্যা",
  MFSvolume: "এমএফএস ভলিউম",
  WithinBankVolume: "ব্যাংকের ভিতরে ভলিউম",
  OtherBankVolume: "অন্যান্য ব্যাংকের ভলিউম",
  PaymentVolume: "পেমেন্ট ভলিউম",

  // IDTP Registration Report
  IDTPRegistrationReport: "আইডিটিপি রেজিস্ট্রেশন রিপোর্ট",
  VID: "ভিআইডি",
  DefualtDebitAccount: "ডিফল্ট ডেবিট অ্যাকাউন্ট",
  DefualtCreditAccount: "ডিফল্ট ক্রেডিট অ্যাকাউন্ট",
  DefualtRTPAccount: "ডিফল্ট আরটিপি অ্যাকাউন্ট",
  RegistrationType: "রেজিস্ট্রেশন ধরণ",

  // IDTP Transfer Report
  IDTPTransferReport: "আইডিটিপি ট্রান্সফার রিপোর্ট",
  SenderVID: "প্রেরক ভিআইডি",
  ReceiverVID: "প্রাপক ভিআইডি",
  ReceiverName: "প্রাপকের নাম",
  InterOperableFee: "ইন্টারঅপারেবল ফি",
  PlatformFee: "প্ল্যাটফর্ম ফি",
  RTPID: "আরটিপি আইডি",
  SwiftCode: "সুইফ্ট কোড",
  SDKResponseCode: "এসডিকের রেসপন্স কোড",
  ReqestID: "অনুরোধ আইডি",
  ReferanceNumber: "রেফারেন্স নাম্বার",
  RefNoSendingPSP: "রেফ.নং প্রেরণকারী পিএসপি",
  RefNoReceivingPSP: "রেফ.নং গ্রহণকারী পিএসপি",
  RefNoReceivingBank: "রেফ.নং গ্রহণকারী ব্যাংক",
  RefNoIDTP: "রেফ.নং আইডিটিপি",

  // IDTP Create RTP Report
  IDTPCreateRTPReport: "আইডিটিপি তৈরি আরটিপি রিপোর্ট",
  UserVID: "ব্যবহারকারী ভিআইডি",

  // IDTP Beneficiary Detail Report
  IDTPBeneficiaryDetailReport: "আইডিটিপি সুবিধাভোগী বিবরণ রিপোর্ট",
  BeneficiaryVID: "সুবিধাভোগী ভিআইডি",

  // IDTP Transaction PIN Change Report
  IDTTransactionPINChangeReport: "আইডিটিপি লেনদেন পিআইএন পরিবর্তন রিপোর্ট",

  // Password Reset Through Admin Panel Report
  PasswordResetThroughAdminPanelReport:
    "অ্যাডমিন প্যানেল রিপোর্ট এর মাধ্যমে পাসওয়ার্ড রিসেট",
  MakerMachine: "তৈরি মেশিন",
  CheckerMachine: "চেকার মেশিন",

  // IDTP Forgot PIN Report
  IDTPForgotPINReport: "আইডিটিপি পিআইএন ভুলে গেছে রিপোর্ট",
  VirtualID: "ভার্চুয়াল আইডি",
  AcOrCardNumber: "হিসাব বা কার্ড নম্বর",

  // IDTP RTP Decline Report
  IDTPRTPDeclineReport: "আইডিটিপি আরটিপি প্রত্যাখ্যান রিপোর্ট",
  SenderName: "প্রেরকের নাম",
  SenderVirtualID: "প্রেরকের ভার্চুয়াল আইডি",

  // Virtual Card Request Report
  VirtualCardRequestReport: "ভার্চুয়াল কার্ড অনুরোধ রিপোর্ট",
  CardProductName: "কার্ড পণ্যের নাম",
  NameOnCard: "কার্ডের উপরের নাম",
  CurrencyCode: "মুদ্রা কোড",
  PassportNumber: "পাসপোর্ট নম্বর",
  CorrespondenceAddress: "প্রেরণাধীন ঠিকানা",

  // Dynamic Report Configure
  DynamicReportConfigure: "ডায়নামিক রিপোর্ট কনফিগার করুন",
  SQLANSIQuerySyntax: "SQL ANSI ক্যুয়ারি সিনট্যাক্স",
  PleaseEnterSQLSyntax: "SQL সিনট্যাক্স লিখুন দয়া করে।",
  PleaseVerifySQLSyntax: "SQL সিনট্যাক্স যাচাই করুন দয়া করে।",
  Parameters: "প্যারামিটার",
  Title: "শিরোনাম",
  EnterTitle: "শিরোনাম লিখুন",
  RetrievalType: "পুনরুদ্ধার প্রকার",
  DisableGroupBy: "গ্রুপ করা বন্ধ করুন",
  HideAmountIn: "পরিমাণ লুকান",
  HideFooter: "ফুটার লুকান",
  ColumnAccessor: "কলাম এক্সেসর",
  EnterColumnAccessor: "কলাম এক্সেসর লিখুন",
  ColumnName: "কলামের নাম",
  EnterColumnName: "কলামের নাম লিখুন",
  ColumnWidth: "কলাম প্রস্থ",
  EnterColumnWidth: "কলাম প্রস্থ লিখুন",
  ColumnType: "কলামের ধরন",
  EnterColumnType: "কলামের ধরন লিখুন",
  ColumnFilterType: "কলাম ফিল্টারের ধরন",
  IsVisible: "দৃশ্যমান",
  CreatedBy: "তৈরি করেছেন",
  CreatedDate: "তৈরির তারিখ",
  QuerySuccessfullyVerified: "ক্যুয়ারি সফলভাবে যাচাই করা হয়েছে।",
  ColumnFormat: "কলাম ফরমেট",
  EnterColumnFormat: "কলাম ফরমেট লিখুন",
  WhereSequence: "কোথাও ক্রম",
  EnterWhereSequence: "কোথাও ক্রম লিখুন",
  AccessRights: "অ্যাক্সেস অধিকার",
  DynamicReportAccessRights: "ডায়নামিক রিপোর্টের অ্যাক্সেস অধিকার",
  Userrightsupdatedsuccessfully: "ব্যবহারকারীর অধিকার সফলভাবে আপডেট হয়েছে।",
  Verify: "যাচাই করুন",
  Done: "হয়ে গেছে",

  UserList: "ব্যবহারকারীর তালিকা",
  Club: "ক্লাব",

  startswith: "দিয়ে শুরু করুন",
  endswith: "দিয়ে শেষ হয়৷",
  equal: "সমান",
  contains: "ধারণ করে",

  PleaseSelectValidStartTime: "অনুগ্রহ করে বৈধ শুরুর সময় নির্বাচন করুন",
  PleaseSelectValidEndTime: "অনুগ্রহ করে বৈধ শেষ সময় নির্বাচন করুন",
  MonthlyLimitshouldgreaterthanorequaltoDailyLimit:
    "মাসিক সীমা দৈনিক সীমার চেয়ে বেশি বা সমান হওয়া উচিত",
  MonthlyLimitshouldgreaterthanorequaltoWeeklyLimit:
    "মাসিক সীমা সাপ্তাহিক সীমার চেয়ে বেশি বা সমান হওয়া উচিত",
  MaximumAmountshouldgreaterthanorequaltoMinimumAmount:
    "সর্বাধিক পরিমাণ সর্বনিম্ন পরিমাণের চেয়ে বেশি বা সমান হওয়া উচিত",
  WeeklyLimitshouldgreaterthanorequaltoDailyLimit:
    "সাপ্তাহিক সীমা দৈনিক সীমার চেয়ে বেশি বা সমান হওয়া উচিত",

  viewmode: "ভিউ মোড",
  newmode: "নতুন মোড",
  editmode: "সম্পাদনা মোড",
  confirmmode: "নিশ্চিত মোড",
  addmode: "মোড যোগ করুন",

  SelectCompute: "সিলেক্ট করুন কম্পিউট",
  BusinessDayhasbeennotgeneratedPleasegenerateaBusinessDaythroughtheViewDetailsScreen:
    "ব্যবসা দিবস তৈরি করা হয়নি। দেখুন বিস্তারিত স্ক্রীনের মাধ্যমে একটি ব্যবসা দিবস তৈরি করুন।",
  SelectBranchName: "শাখার নাম নির্বাচন করুন",
  StartdatemustbegreaterthanpreviousEnddate:
    "শুরুর তারিখ অবশ্যই আগের শেষ তারিখের থেকে বেশি হতে হবে",
  SelectParentType: "প্যারেন্ট টাইপ নির্বাচন করুন",
  SelectLeavesTemplate: "ছুটির টেমপ্লেট নির্বাচন করুন",
  SelectCharges: "চার্জ নির্বাচন করুন",
  SelectOperatorType: "অপারেটর টাইপ নির্বাচন করুন",
  SelectOptionType: "বিকল্প প্রকার নির্বাচন করুন",
  SelectChargeTemplate: "চার্জ টেমপ্লেট নির্বাচন করুন",
  SelectAccountSource: "অ্যাকাউন্ট উত্স নির্বাচন করুন",
  DragandDropor: "টেনে আনুন বা ড্রপ করুন",
  Browse: "ব্রাউজ",
  DropFileshere: "এখানে ফাইল ড্রপ করুন",
  SelectSourceName: "উৎসের নাম নির্বাচন করুন",
  SelectSourceType: "সোর্স টাইপ নির্বাচন করুন",
  SelectDistrict: "জেলা নির্বাচন করুন",
  SelectTransactionType: "লেনদেনের ধরন নির্বাচন করুন",
  SelectAccountType: "অ্যাকাউন্টের ধরন নির্বাচন করুন",
  SelectTenureType: "মেয়াদের ধরন নির্বাচন করুন",
  SelectRestrictionType: "সীমাবদ্ধতার ধরন নির্বাচন করুন",
  SelectUsecase: "ইউজ কেস নির্বাচন করুন",
  SelectChannel: "চ্যানেল নির্বাচন করুন",
  SelectDisplayType: "ডিসপ্লে প্রকার নির্বাচন করুন",
  SelectBannerType: "ব্যানার প্রকার নির্বাচন করুন",
  SelectTenureTypeFinacle: "মেয়াদ প্রকার ফিনাকল নির্বাচন করুন",
  SelectRenewal: "নবীকরণ নির্বাচন করুন",
  SelectDataType: "ডেটা টাইপ নির্বাচন করুন",
  SelectMFSService: "MFS সেবা নির্বাচন করুন",
  //
  SelectDescription: "বর্ণনা নির্বাচন করুন",
  SelectAllowDisallow: "অনুমতি দিন/অনুমতি দিন নির্বাচন করুন",
  SelectTemplate: "টেমপ্লেট নির্বাচন করুন",
  SelectCardStatus: "কার্ড অবস্থা নির্বাচন করুন",
  SelectOperationType: "অপারেশন প্রকার নির্বাচন করুন",
  SelectEnableStatus: "সক্রিয় অবস্থা নির্বাচন করুন",
  SelectDeviceOS: "ডিভাইস অপারেটিং সিস্টেম নির্বাচন করুন",
  SelectServiceName: "পরিষেবার নাম নির্বাচন করুন",
  SelectTemplateName: "টেমপ্লেট নাম নির্বাচন করুন",
  SelectProductType: "পণ্যের ধরন নির্বাচন করুন",
  SelectLimitCurrency: "সীমিত মুদ্রা নির্বাচন করুন",
  SelectLanguageID: "ভাষা আইডি নির্বাচন করুন",
  SelectMerchantID: "মার্চেন্ট আইডি নির্বাচন করুন",
  SelectTerminalID: "টার্মিনাল আইডি নির্বাচন করুন",
  SelectCharge: "চার্জ নির্বাচন করুন",
  SelectGatewayNamePID: "গেটওয়ে নাম (PID) নির্বাচন করুন",
  SelectUserRole: "ব্যবহারকারী ভূমিকা নির্বাচন করুন",
  SelectUserStatus: "ব্যবহারকারী স্থিতি নির্বাচন করুন",
  SelectActionMenu: "অ্যাকশন মেনু নির্বাচন করুন",
  SelectResponseKey: "প্রতিক্রিয়া কী নির্বাচন করুন",
  SelectUserLevel: "ব্যবহারকারীর স্তর নির্বাচন করুন",
  SelectGroupName: "গ্রুপ নাম নির্বাচন করুন",
  SelectUserSubType: "ইউজার সাব টাইপ নির্বাচন করুন",
  SelectNotificationTemplate: "বিজ্ঞপ্তি টেমপ্লেট নির্বাচন করুন",
  SelectUserLoginID: "ব্যবহারকারী লগইন আইডি নির্বাচন করুন",
  ErrorDetails: "ত্রুটি বিস্তারিত",
  ShowLess: "দেখান কম",
  ShowMore: "দেখান আরও",
  Atleastonerowmustbeindetail: "অন্তত একটি সারি বিস্তারিত হতে হবে.",
  All: "সব",
  UploadProfilePhoto: "প্রোফাইল ফটো আপলোড করুন",
  Filenotfound: "ফাইল পাওয়া যায়নি",
  Profilepictureupdatedsuccessfully: "প্রোফাইল ছবি সফলভাবে আপডেট করা হয়েছে৷",
  Zoom: "জুম",
  Rotate: "আবর্তিত",
  UpdatePhoto: "ফটো আপডেট করুন",
  ServiceChargeDetails: "সেবা চার্জ বিবরণ",
  Addedsuccessfully: "সফলভাবে যোগ করা হয়েছে",
  Updatedsuccessfully: "সফলভাবে আপডেট করা হয়েছে",
  EditChargeTemplate: "চার্জ টেমপ্লেট সম্পাদনা করুন",
  AreyousureyouwanttodeletetheselectedRecord:
    "আপনি কি নিশ্চিত যে আপনি নির্বাচিত রেকর্ডটি মুছতে চান?",
  Disagree: "অসম্মত",
  Agree: "সম্মত",
  EditChecklistDetails: "চেকলিস্ট বিবরণ সম্পাদনা করুন",
  EnterFromAmount: "পরিমাণ লিখুন",
  EnterToAmount: "পরিমাণ লিখুন",
  EnterChargeAmount: "চার্জের পরিমাণ লিখুন",
  EnterChargePercent: "চার্জ শতাংশ লিখুন",
  AddChargeTemplateDetail: "চার্জ টেমপ্লেট বিবরণ যোগ করুন",
  AccessDenied: "অ্যাক্সেস অস্বীকৃত!",
  Usernameisnotvalid: "ব্যবহারকারীর নাম বৈধ নয়",
  OopsPageNotFound: "উফ! পৃষ্ঠা খুঁজে পাওয়া যায়নি",
  Pleaseselectatleastonecolumn: "অনুগ্রহ করে অন্তত একটি কলাম নির্বাচন করুন!",
  Nodatafoundtoexports: "রপ্তানি করার জন্য কোন তথ্য পাওয়া যায়নি!",
  ResendOTP: "OTP আবার পাঠান",

  OTPVerification: "OTP যাচাইকরণ",
  PleaseEnterOTP: "অনুগ্রহ করে ওটিপি লিখুন",
  ForgotTOTP: "TOTP ভুলে গেছি",

  SelectCategory: "বিভাগ নির্বাচন করুন",
  SelectBillerName: "বিলারের নাম নির্বাচন করুন",
  SelectTrnStatus: "Trn স্থিতি নির্বাচন করুন",
  SelectStatus: "স্থিতি নির্বাচন করুন",
  SelectOTPType: "OTP প্রকার নির্বাচন করুন",
  SelectMerchantName: "ব্যবসায়ীর নাম নির্বাচন করুন",
  SelectTransactionStatus: "লেনদেনের স্থিতি নির্বাচন করুন",
  SelectFrequency: "ফ্রিকোয়েন্সি নির্বাচন করুন",
  SelectAccessChannel: "অ্যাক্সেস চ্যানেল নির্বাচন করুন",
  AreyousureyouwanttodeletetheselectedRecords:
    "আপনি কি নিশ্চিত যে আপনি নির্বাচিত রেকর্ডগুলি মুছে ফেলতে চান৷",
  AllRecordssuccessfullydeleted: "সমস্ত রেকর্ড সফলভাবে মুছে হয়েছে৷",
  LoginPasswordForceExpiryDaysmustbeavalidnumberbetween1to30:
    "লগইন পাসওয়ার্ড ফোর্স মেয়াদ শেষ হওয়ার দিনগুলি অবশ্যই 1 থেকে 30 এর মধ্যে একটি বৈধ সংখ্যা হতে হবে৷",

  IDTPAliasUpdateReport: "IDTP উপনাম আপডেট রিপোর্ট",
  ExistingAlias: "বিদ্যমান উপনাম",
  NewAlias: "দেখুন উপনাম",
  SelectLanguage: "ভাষা নির্বাচন কর",
  AreyouSureyouwanttodeletethisrecord:
    "আপনি কি নিশ্চিত আপনি আপনার রেকর্ড মুছে ফেলতে চান?",
  Recordsuccessfullydeleted: "রেকর্ড সফলভাবে মুছে ফেলা হয়েছে",
  Pleasewaitdeletingrecord: "রেকর্ড মুছে ফেলার জন্য অপেক্ষা করুন",
  NoRecordsFoundclicktheaddbuttontoaddone:
    "কোনো রেকর্ড পাওয়া যায়নি, একটি যোগ করতে অ্যাড বোতামে ক্লিক করুন",
  Maximize: "সর্বাধিক করুন",
  EnterDefaultValue: "ডিফল্ট মান লিখুন",
  IsTotalWithoutCurrency: "মুদ্রা ছাড়া মোট হয়",
  IsTotalWithCurrency: "মুদ্রার সাথে মোট",
  IsVisibleCurrencySymbol: "দৃশ্যমান মুদ্রার প্রতীক",
  IsCurrencyCode: "কারেন্সি কোড",
  CurrencyReferenceColumn: "কারেন্সি রেফারেন্স কলাম",

  //Password Rotation
  PasswordRotation: "পাসওয়ার্ড ঘূর্ণন",
  CurrentPassword: "বর্তমান পাসওয়ার্ড",
  EnterCurrentPassword: "বর্তমান পাসওয়ার্ড লিখুন",
  EnterNewPassword: "নতুন পাসওয়ার্ড লিখুন",
  ConfirmNewPassword: "নিশ্চিত কর নতুন গোপননম্বর",
  Enterconfirmnewpassword: "নতুন পাসওয়ার্ড নিশ্চিত করুন",
  CurrentPasswordisrequired: "বর্তমান পাসওয়ার্ড প্রয়োজন.",
  Thenewpasswordcannotbethesameastheoldpassword:
    "নতুন পাসওয়ার্ড পুরানো পাসওয়ার্ডের মতো হতে পারে না",
  Confirmnewpasswordisrequired: "নিশ্চিত করুন নতুন পাসওয়ার্ড প্রয়োজন.",
  NewPasswordandConfirmPassworddidnotmatched:
    "নতুন পাসওয়ার্ড এবং কনফার্ম পাসওয়ার্ড মেলেনি",
  Passwordsuccessfullychanged: "পাসওয়ার্ড সফলভাবে পরিবর্তন।",

  //
  CardProductBin: "কার্ড পণ্য বিন",
  ModeofOperation: "অপারেশনের মোড",
  AccountStatus: "অ্যাকাউন্ট স্ট্যাটাস",

  //Push Notification Master
  PushNotificationMaster: "পুশ নোটিফিকেশন মাস্টার",
  UserType: "ব্যবহারকারীর ধরন",
  SelectUserType: "ব্যবহারকারীর ধরন নির্বাচন করুন",
  ExecuteDate: "তারিখ কার্যকর করুন",
  EnterExecuteDate: "এক্সিকিউট ডেট লিখুন",
  SelectLoginID: "লগইন আইডি নির্বাচন করুন",
  EnterCustomerName: "গ্রাহকের নাম লিখুন",
  EnterLastLoginDate: "শেষ লগইন তারিখ লিখুন",
  PushNotificationMasterConfirmation: "পুশ নোটিফিকেশন মাস্টার কনফার্মেশন",

  // Push Notification Template Configuration
  PushNotificationTemplateConfiguration: "পুশ বিজ্ঞপ্তি টেমপ্লেট কনফিগারেশন",
  Subject: "বিষয়",
  EnterSubject: "বিষয় লিখুন",
  EnterTemplateName: "টেমপ্লেট নাম লিখুন",
  PushNotificationTemplateConfigurationPreview:
    "পুশ বিজ্ঞপ্তি টেমপ্লেট কনফিগারেশন পূর্বরূপ",
  EnterDeviceID: "ডিভাইস আইডি লিখুন",
  Preview: "পূর্বরূপ",
  Test: "পরীক্ষা",
  PushNotificationTemplateConfirmation: "পুশ বিজ্ঞপ্তি টেমপ্লেট নিশ্চিতকরণ",
  FromAmountshouldbelessToAmount: "থেকে পরিমাণ থেকে কম হওয়া উচিত",

  Mobilenumbermustbe11digitslong: "মোবাইল নম্বরটি 11 সংখ্যার হতে হবে",
  UserRestrictProcessing: "ব্যবহারকারী সীমাবদ্ধ প্রক্রিয়াকরণ",
  PrimaryStatus: "প্রাথমিক স্ট্যাটাস",
  CardID: "কার্ড আইডি",
  EnterCardID: "কার্ড আইডি লিখুন",
  TapPayDetails: "ট্যাপ করুন এবং বিশদ প্রদান করুন",
  TapPay: "আলতো চাপুন এবং অর্থ প্রদান করুন",

  //IBMB Product

  LanguageReq: "ভাষা*",
  MessageReq: "মেসেজ*",
  EnterMessage: "মেসেজ এন্টার করুন",
  MessageNoteReq: "মেসেজ নোট*",
  MessageNote: "মেসেজ নোট",
  EnterMessageNote: "বার্তা নোট লিখুন",
  EnterMessageCode: "বার্তা কোড লিখুন",
  LanguageisAlreadyenteredatLine:
    "ভাষা ইতিমধ্যেই লাইন {0} এ প্রবেশ করানো হয়েছে",
  EnterDefaultMessage: "ডিফল্ট বার্তা লিখুন",
  DefaultMessage: "ডিফল্ট বার্তা",
  SelectCurrencyCode: "মুদ্রা কোড নির্বাচন করুন",
  DefaultNote: "ডিফল্ট নোট",
  EnterDefaultNote: "ডিফল্ট নোট লিখুন",

  CommonMessageTemplate: "কমন মেসেজ টেমপ্লেট",
  Message: "মেসেজ",
  SelectMessage: "বার্তা নির্বাচন করুন",

  PasswordPolicyConfiguration: "পাসওয়ার্ড নীতি কনফিগারেশন",
  PasswordType: "পাসওয়ার্ড টাইপ",
  MinimumLength: "ন্যূনতম দৈর্ঘ্য",
  MaximumLength: "সর্বাধিক দৈর্ঘ্য",
  UpperCaseRequire: "বড় হাতের অক্ষর প্রয়োজন",
  LowerCaseRequire: "ছোট হাতের অক্ষর প্রয়োজন",
  SpecialCharacterRequire: "বিশেষ অক্ষর প্রয়োজন",
  DigitsRequire: "সংখ্যা প্রয়োজন",
  NoSpaces: "কোনো স্থান নেই",
  EnterPasswordType: "পাসওয়ার্ড টাইপ লিখুন",
  EnterMinimumLength: "ন্যূনতম দৈর্ঘ্য লিখুন",
  EnterMaximumLength: "সর্বাধিক দৈর্ঘ্য লিখুন",
  NoofPreviousPasswordNotAllowed: "পূর্ববর্তী পাসওয়ার্ডের সংখ্যা অনুমোদিত নয়",
  EnterNoofPreviousPasswordNotAllowed:
    "অনুমোদিত নয় এমন পূর্ববর্তী পাসওয়ার্ডের সংখ্যা লিখুন",
  MinimumUpperCase: "ন্যূনতম বড় হাতের অক্ষর",
  EnterMinimumUpperCase: "ন্যূনতম বড় হাতের অক্ষর লিখুন",
  MinimumLowerCase: "ন্যূনতম ছোট হাতের অক্ষর",
  EnterMinimumLowerCase: "ন্যূনতম ছোট হাতের অক্ষর লিখুন",
  MinimumDigits: "ন্যূনতম সংখ্যা",
  EnterMinimumDigits: "ন্যূনতম সংখ্যা লিখুন",
  MinimumSpecialCharater: "ন্যূনতম বিশেষ অক্ষর",
  EnterMinimumSpecialCharater: "ন্যূনতম বিশেষ অক্ষর লিখুন",
  AllowedSpecialCharacter: "অনুমোদিত বিশেষ অক্ষর",
  EnterAllowedSpecialCharacter: "অনুমোদিত বিশেষ অক্ষর লিখুন",
  MinimumEnglishCharacter: "ন্যূনতম ইংরেজি অক্ষর",
  EnterMinimumEnglishCharacter: "ন্যূনতম ইংরেজি অক্ষর লিখুন",
  ExpireDays: "মেয়াদ উত্তীর্ণ দিন",
  EnterExpireDays: "মেয়াদ উত্তীর্ণ দিন লিখুন",
  AlertBeforeExpireDays: "মেয়াদ উত্তীর্ণ হওয়ার আগে সতর্ক করুন",
  EnterAlertBeforeExpireDays: "মেয়াদ উত্তীর্ণ হওয়ার আগে সতর্ক করুন লিখুন",
  Pleaseenteronlyspecialcharacters: "দয়া করে শুধুমাত্র বিশেষ অক্ষর লিখুন",

  EnterAccountSource: "অ্যাকাউন্টের উৎস লিখুন",
  EnterAccountType: "অ্যাকাউন্টের ধরন লিখুন",
  EditAllowed: "সম্পাদনা অনুমোদিত",
  EnteraproperVersion: "একটি সঠিক সংস্করণ লিখুন",
  InternetBanking: "ইন্টারনেট ব্যাংকিং",
  MobileBanking: "মোবাইল ব্যাংকিং",
  MaskedAccountCardNo: "মাস্কড অ্যাকাউন্ট কার্ড নম্বর",

  AccountCustomerID: "অ্যাকাউন্ট গ্রাহক আইডি",
  AccountRegCardNo: "অ্যাকাউন্ট/রেজি/কার্ড নম্বর",
  MakerRemarks: "মেকার মন্তব্য",
  PrimaryCustomerID: "প্রাথমিক গ্রাহক আইডি",

  SecurityQuestionMasterConfiguration: "নিরাপত্তা প্রশ্ন মাস্টার কনফিগারেশন",
  SecurityQuestion: "নিরাপত্তা প্রশ্ন",
  SecurityQuestionGroupCD: "নিরাপত্তা প্রশ্ন গ্রুপ",
  EnterSecurityQuestions: "নিরাপত্তা প্রশ্ন প্রবেশ করুন",
  SecurityQuestionConfigurationConfirmation:
    "নিরাপত্তা প্রশ্ন কনফিগারেশন নিশ্চিতকরণ",
  SecurityQuestionConfiguration: "নিরাপত্তা প্রশ্ন কনফিগারেশন",
  SelectDefaultMessage: "ডিফল্ট বার্তা নির্বাচন করুন",
  Unknownerroroccured: "অজানা ত্রুটি ঘটেছে",

  OtherBankMaster: "অন্য ব্যাংক মাস্টার",
  OtherBranchMaster: "অন্য ব্রাঞ্চ মাস্টার",
  OtherRegionMaster: "অন্য অঞ্চলের মাস্টার",

  // State Township MAster Configuration Screen

  StateTownshipMasterConfiguration: "রাজ্য টাউনশিপ মাস্টার কনফিগারেশন",
  StateCode: "রাজ্যের কোড",
  EnterStateCode: "রাজ্যের কোড প্রবেশ করুন",
  StateName: "রাজ্যের নাম",
  EnterStateName: "রাজ্যের নাম প্রবেশ করুন",
  TownshipCode: "টাউনশিপ কোড",
  EnterTownshipCode: "টাউনশিপ কোড প্রবেশ করুন",
  TownshipName: "টাউনশিপের নাম",
  EnterTownshipName: "টাউনশিপের নাম প্রবেশ করুন",
  // Suspense Account Template Configuration

  SuspenseAccountTemplateConfiguration:
    "সাসপেন্স অ্যাকাউন্ট টেমপ্লেট কনফিগারেশন",
  SuspenseAccountTemplateConfirmation:
    "সাসপেন্স অ্যাকাউন্ট টেমপ্লেট নিশ্চিতকরণ",
  TransactionRemark1: "লেনদেন মন্তব্য 1",
  EnterTransactionRemark1: "লেনদেন মন্তব্য লিখুন 1",
  TransactionRemark2: "লেনদেন মন্তব্য 2",
  EnterTransactionRemark2: "লেনদেন মন্তব্য লিখুন 2",
  AccountTypeReq: "অ্যাকাউন্ট প্রকার*",
  AccountTypeisAlreadyenteredatLine:
    "অ্যাকাউন্টের প্রকার ইতিমধ্যেই লাইন {0} এ প্রবেশ করানো হয়েছে",
  // Currency Limit Template Configuration

  CurrencyLimitTemplateConfiguration: "মুদ্রা সীমা টেমপ্লেট কনফিগারেশন",
  CurrencyLimitTemplateConfirmation: "মুদ্রা সীমা টেমপ্লেট নিশ্চিতকরণ",
  DailyAmount: "দৈনিক পরিমাণ",
  WeeklyAmount: "সাপ্তাহিক পরিমাণ",
  MonthlyAmount: "মাসিক পরিমাণ",
  MaximumDailyCount: "দৈনিক সর্বাধিক সংখ্যা",
  MaximumWeeklyCount: "সাপ্তাহিক সর্বাধিক সংখ্যা",
  MaximumMonthlyCount: "মাসিক সর্বাধিক সংখ্যা",
  CurrencyCodeReq: "মুদ্রা কোড*",
  EnterOrderBy: "অর্ডার বাই লিখুন",

  CurrencyReq: "মুদ্রা*",
  SelectCurrency: "মুদ্রা নির্বাচন করুন",
  EitherChargeAmountOrChargePercentageIsRequired:
    "চার্জের পরিমাণ বা চার্জের শতাংশের যেকোনো একটি প্রয়োজনীয়",

  AccountSpecificChargeTemplate: "অ্যাকাউন্ট-নির্দিষ্ট চার্জ টেমপ্লেট",
  ServiceChargeTemplateReq: "সার্ভিস চার্জ টেমপ্লেট*",
  AccountClassificationReq: "অ্যাকাউন্ট শ্রেণীবিন্যাস*",
  AcParameterMappingTemplateReq: "অ্যাকাউন্ট প্যারামিটার ম্যাপিং টেমপ্লেট*",
  AccountSpecificChargeTemplateConfirmation:
    "অ্যাকাউন্ট-নির্দিষ্ট চার্জ টেমপ্লেট নিশ্চিতকরণ",
  AccountSourceNumber: "অ্যাকাউন্ট/সূত্র নম্বর",
  ThisCurrencyAlreadyExists: "এই মুদ্রাটি ইতিমধ্যেই বিদ্যমান",
  AccountParametersMappingTemplate: "অ্যাকাউন্ট প্যারামিটার ম্যাপিং টেমপ্লেট",
  FromSourceKeyValueConfigMapping: "সূত্র কী-মান কনফিগারেশন ম্যাপিং থেকে",
  AcParameterMappingTemplate: "অ্যাকাউন্ট প্যারামিটার ম্যাপিং টেমপ্লেট",
  ConfigurationType: "কনফিগারেশন ধরন",
  PresetAmountConfiguration: "পূর্বনির্ধারিত পরিমাণ কনফিগারেশন",
  TemplateCode: "টেমপ্লেট কোড",

  LimitTemplateReq: "সীমা টেমপ্লেট*",
  LimitTemplate: "সীমা টেমপ্লেট",
  SelectLimitTemplate: "সীমা টেমপ্লেট নির্বাচন করুন",
  AccountTemplate: "অ্যাকাউন্ট টেমপ্লেট",
  SelectAccountTemplate: "অ্যাকাউন্ট টেমপ্লেট নির্বাচন করুন",
  GloballimitTemplate: "গ্লোবাল লিমিট টেমপ্লেট",
  SelectGloballimitTemplate: "বিশ্বব্যাপী সীমা টেমপ্লেট নির্বাচন করুন",

  ProfileTemplate: "প্রোফাইল টেমপ্লেট",
  ProfileTemplateConfirmation: "প্রোফাইল টেমপ্লেট নিশ্চিতকরণ৷",
  //service master
  ServiceMaster: "সার্ভিস মাস্টার",
  ServiceMasterConfirmation: "সার্ভিস মাস্টার নিশ্চিতকরণ",
  SuspenseAccountDetails: "সাসপেন্স অ্যাকাউন্টের বিবরণ",
  ChargeAllow: "চার্জ অনুমোদন",
  SuspenseAccountTemplate: "সাসপেন্স অ্যাকাউন্ট টেমপ্লেট",
  SelectSuspenseAccountTemplate: "সাসপেন্স অ্যাকাউন্ট টেমপ্লেট নির্বাচন করুন",
  AccountSourceReq: "অ্যাকাউন্ট উৎস*",

  // Wallet Master
  WalletMaster: "ওয়ালেট মাস্টার",
  WalletMasterConfirmation: "ওয়ালেট মাস্টার নিশ্চিতকরণ",
  WalletType: "ওয়ালেটের ধরন",
  EnterWalletType: "ওয়ালেটের ধরন লিখুন",
  WalletName: "ওয়ালেটের নাম",
  EnterWalletName: "ওয়ালেটের নাম লিখুন",
  WalletIDValidateRegex: "ওয়ালেট আইডি যাচাই করার রেগুলার এক্সপ্রেশন",
  EnterWalletIDValidateRegex:
    "ওয়ালেট আইডি যাচাই করার রেগুলার এক্সপ্রেশন লিখুন",
  WalletIDRegExpNotaValid: "ওয়ালেট আইডি রেগুলার এক্সপ্রেশন একটি বৈধ",

  Areyousureyouwanttoupdatetheprofiletemplateforthisuser:
    "আপনি কি এই ব্যবহারকারীর জন্য প্রোফাইল টেমপ্লেট আপডেট করার বিষয়ে নিশ্চিত?",
  Theholidaydatemustbebetweenthestartdateandenddate:
    "ছুটির তারিখটি শুরুর তারিখ এবং শেষ তারিখের মধ্যে হতে হবে।",
  SelectCardType: "কার্ডের ধরন নির্বাচন করুন",
  CardStatusisAlreadyenteredatLine:
    "কার্ডের স্থিতি ইতিমধ্যে লাইন {0} এ প্রবেশ করানো হয়েছে",
  CardCategory: "কার্ড বিভাগ",
  CardApplyConfirmation: "কার্ডের আবেদন নিশ্চিতকরণ",
  ProofType: "প্রুফ টাইপ",
  ProofValue: "প্রুফ ভ্যালু",
  CardApplyDetails: "কার্ডের আবেদনের বিবরণ",
  ClicktoViewFullImage: "সম্পূর্ণ ছবি দেখতে ক্লিক করুন",
  DoubleClicktoCloseImage: "ছবি বন্ধ করতে ডাবল ক্লিক করুন",
  RequestDetail: "বিস্তারিত অনুরোধ করুন",
  ApplyAnnualExpense: "বার্ষিক ব্যয় প্রয়োগ করুন",
  EnterApplyAnnualExpense: "বার্ষিক ব্যয় লিখুন",
  ApplyAnnualIncome: "বার্ষিক আয় প্রয়োগ করুন",
  EnterApplyAnnualIncome: "বার্ষিক আয় লিখুন",
  ApplyCompanyName: "কোম্পানির নাম প্রয়োগ করুন",
  EnterApplyCompanyName: "কোম্পানির নাম লিখুন",
  ApplyPosition: "পদ প্রয়োগ করুন",
  EnterApplyPosition: "পদ লিখুন",
  EnterCardCategory: "ကတ်အမျိုးအစားကို ထည့်သွင်းပါ။",

  CredentialsResetRequestHistoryReport:
    "শংসাপত্র রিসেট অনুরোধ ইতিহাস প্রতিবেদন",
  AuthenticationFlow: "প্রমাণীকরণ প্রবাহ",
  BankRegion: "ব্যাংক অঞ্চল",
  MobileAccountLinkReport: "মোবাইল অ্যাকাউন্ট লিঙ্ক প্রতিবেদন",
  ActionFlag: "ক্রিয়া পতাকা",
  TRFType: "TRF প্রকার",
  WalletTopUpDetails: "ওয়ালেট টপ আপ বিবরণ",
  ToWalletId: "ওয়ালেট আইডি-তে",
  ToWalletNM: "ওয়ালেট নাম-এ",
  OtherBankFundTransferDetails: "অন্যান্য ব্যাংকের তহবিল স্থানান্তর বিবরণ",
  NRCFundTransferDetails: "এনআরসি তহবিল স্থানান্তর বিবরণ",
  CreditCardPaymentDetails: "ক্রেডিট কার্ড পেমেন্ট বিবরণ",
  RecipientMobileNo: "প্রাপকের মোবাইল নম্বর",
  FormAccountNo: "থেকে অ্যাকাউন্ট নম্বর",
  CardResetPinReport: "কার্ড রিসেট পিন প্রতিবেদন",
  PinChangeReason: "পিন পরিবর্তনের কারণ",
  CardApplicationDetails: "কার্ড অ্যাপ্লিকেশন বিবরণ",
  PartyDetails: "পার্টি বিবরণ",
  BlockUnblockCardPinDetails: "ব্লক/আনব্লক কার্ড পিন বিবরণ",
  CardActivationDetails: "কার্ড সক্রিয়করণ বিবরণ",
  MobileNoLengthGreter6Digit:
    "মোবাইল নং দৈর্ঘ্য অবশ্যই 6 সংখ্যার বেশি হতে হবে।",

  InActiveDate: "নিষ্ক্রিয় তারিখ",
  TransactionAllowed: "লেনদেন অনুমোদিত",
  selectTransactionAllowed: "লেনদেন অনুমোদিত নির্বাচন করুন",
  Mobilenumbermustbe9digitslong: "মোবাইল নম্বর ৯ সংখ্যার হতে হবে",
  Mobilenumbermustbe7digitslong: "মোবাইল নম্বর 7 সংখ্যার হতে হবে",
  SearchServiceName: "সার্চ সার্ভিসের নাম",
  AppliedLimits: "প্রযোজ্য সীমা",
  EnterAccountCardNumber: "অ্যাকাউন্ট/কার্ড নম্বর লিখুন",
  EnterAccountCustomerID: "অ্যাকাউন্ট কাস্টমার আইডি লিখুন",

  CardProductMaster: "কার্ড পণ্য মাস্টার",

  StatementType: "স্টেটমেন্ট টাইপ",
  SentStatus: "পাঠানো স্ট্যাটাস",
  AccountStatementReport: "অ্যাকাউন্ট স্টেটমেন্ট রিপোর্ট",
  ChargeAmount: "চার্জের পরিমাণ",
  ToSourceFlag: "উৎস পতাকা",
  ServiceUnavailableAction: "সেবা অপ্রাপ্য কর্ম",
  SelectServiceUnavailableAction: "সেবা অপ্রাপ্য কর্ম নির্বাচন করুন",
  ServiceUnavailableActionReq: "সেবা অপ্রাপ্য কর্ম*",
  AllowAccess: "অ্যাক্সেস অনুমতি দিন",
  ProfileReq: "প্রোফাইল*",
  SelectProfile: "প্রোফাইল নির্বাচন করুন",
  ThisChannelalreadyexists: "এই চ্যানেলটি ইতিমধ্যেই বিদ্যমান",
  ThisProfilealreadyexists: "এই প্রোফাইলটি ইতিমধ্যেই বিদ্যমান",
  BranchMasterConfirmation: "শাখা মাস্টার নিশ্চিতকরণ",
  FromSourceKeyValueConfigurationConfirmation:
    "উৎস কী মান কনফিগারেশন নিশ্চিতকরণ",
  FromSourceKeyValueConfirmation: "উৎস কী মান নিশ্চিতকরণ",

  IntraFundTransferDetails: "ইনট্রা ফান্ড ট্রান্সফার লেনদেনের বিবরণ",
  ErrorCode: "ত্রুটি কোড",
  ToAccountCardNo: "অ্যাকাউন্ট/কার্ড নম্বর",
  CardApplicationPartiesDetails: "কার্ড অ্যাপ্লিকেশন পার্টির বিবরণ",
  FromAccountBalance: "হিসাবের ব্যালেন্স থেকে",
  RetryCount: "পুনরায় চেষ্টা সংখ্যা",
  CallResponse: "কলের প্রতিক্রিয়া",
  ReferenceID: "রেফারেন্স আইডি",
  RefereneceDate: "রেফারেন্স তারিখ",
  BatchID: "ব্যাচ আইডি",
  APIStatus: "API স্থিতি",
  CardProductMasterConfirmation: "কার্ড পণ্য মাস্টার নিশ্চিতকরণ",
  ChannelLimit: "চ্যানেল সীমা",
  ChannelLimitConfiguration: "চ্যানেল সীমা কনফিগারেশন",
  ChannelLimitConfirmation: "চ্যানেল সীমা নিশ্চিতকরণ",
  TransactionAllowedReq: "লেনদেন অনুমোদিত*",

  BranchServiceStatusTitle: "শাখা পরিষেবা স্থিতি আপডেট",
  BranchServiceStatusCountNote: "নির্বাচিত শাখা: ",
  BranchServiceStatusNote:
    "বিঃদ্রঃ: সমস্ত নির্বাচিত শাখার জন্য পরিষেবা এবং স্থিতি আপডেট করার জন্য অনুগ্রহ করে নির্বাচন করুন।",
  BranchServiceStatusUpdateMsg:
    "আপনি কি নিশ্চিত যে আপনি সমস্ত নির্বাচিত শাখায় {1} পরিষেবাটি {0} করতে চান?",
  Specialcharactersandspacesarenotallowed:
    "Special characters and spaces are not allowed",
};
